export const ringBackToneData = [
  { value: "${au-ring}", label: "au-ring" },
  { value: "${be-ring}", label: "be-ring" },
  { value: "${bong-ring}", label: "bong-ring" },
  { value: "${ca-ring}", label: "ca-ring" },
  { value: "${cn-ring}", label: "cn-ring" },
  { value: "${cy-ring}", label: "cy-ring" },
  { value: "${cz-ring}", label: "cz-ring" },
  { value: "${de-ring}", label: "de-ring" },
  { value: "${dk-ring}", label: "dk-ring" },
  { value: "${dz-ring}", label: "dz-ring" },
  { value: "${eg-ring}", label: "eg-ring" },
  { value: "${fi-ring}", label: "fi-ring" },
  { value: "${fr-ring}", label: "fr-ring" },
  { value: "${hk-ring}", label: "hk-ring" },
  { value: "${hu-ring}", label: "hu-ring" },
  { value: "${il-ring}", label: "li-ring" },
  { value: "${in-ring}", label: "in-ring" },
  { value: "${it-ring}", label: "it-ring" },
  { value: "${jp-ring}", label: "jp-ring" },
  { value: "${ko-ring}", label: "ko-ring" },
  { value: "${pk-ring}", label: "pk-ring" },
  { value: "${pl-ring}", label: "pl-ring" },
  { value: "${pt-ring}", label: "pt-ring" },
  { value: "${ro-ring}", label: "ro-ring" },
  { value: "${rs-ring}", label: "rs-ring" },
  { value: "${ru-ring}", label: "ru-ring" },
  { value: "${sa-ring}", label: "sa-ring" },
  { value: "${tr-ring}", label: "tr-ring" },
  { value: "${uk-ring}", label: "uk-ring" },
  { value: "${us-ring}", label: "us-ring" },
];

export const destinationOptions = [
  { value: "", label: "Select" },
  { value: "extension", label: "Extension" },
  { value: "recoreding", label: "Recording" },
  { value: "ringGroup", label: "Ring Group" },
  { value: "callFlow", label: "Call Flow" },
  { value: "iVR", label: "IVR" },
  { value: "voiceMail", label: "VoiceMail" },
  { value: "tones", label: "Tones" },
  // { value: "time_condition", label: "Time Condition" },
  { value: "others", label: "Others" },
];

export const destination2 = [
  { label: "Select", value: "" },
  { label: "Extension", value: "extension" },
  { label: "Recording", value: "recording" },
  { label: "Ring Group", value: "ring_group" },
  { label: "Call Flow", value: "call_flow" },
  { label: "IVR", value: "ivr_menu" },
  { label: "VoiceMail", value: "voicemail" },
  { label: "Tones", value: "tones" },
  { label: "Time Condition", value: "time_condition" },
  { label: "Call Center", value: "call_center" },
  { label: "Other", value: "other" },
];

export const followMeExtensionDestinations = [
  { label: "Select", value: "" },
  { label: "Extension", value: "extension" },
  { label: "Ring Group", value: "ring_group" },
  { label: "Call Flow", value: "call_flow" },
  { label: "IVR", value: "ivr_menu" },
  { label: "Time Condition", value: "time_condition" },
  { label: "Call Center", value: "call_center" },
];

export const tonesOptions = [
  {
    value: "bong-us-tone",
    label: "bong-us-tone",
  },
  {
    value: "busy-au-tone",
    label: "busy-au-tone",
  },
  {
    value: "busy-us-tone",
    label: "busy-us-tone",
  },
  {
    value: "vacant-uk-tone",
    label: "vacant-uk-tone",
  },
  {
    value: "vacant-us-tone",
    label: "vacant-us-tone",
  },
];

export const soundOptions = [
  { value: "ascii/100.wav", text: "ascii/100.wav" },
  { value: "ascii/101.wav", text: "ascii/101.wav" },
  { value: "ascii/102.wav", text: "ascii/102.wav" },
  { value: "ascii/103.wav", text: "ascii/103.wav" },
  { value: "ascii/104.wav", text: "ascii/104.wav" },
  { value: "ascii/105.wav", text: "ascii/105.wav" },
  { value: "ascii/106.wav", text: "ascii/106.wav" },
  { value: "ascii/107.wav", text: "ascii/107.wav" },
  { value: "ascii/108.wav", text: "ascii/108.wav" },
  { value: "ascii/109.wav", text: "ascii/109.wav" },
  { value: "ascii/110.wav", text: "ascii/110.wav" },
  { value: "ascii/111.wav", text: "ascii/111.wav" },
  { value: "ascii/112.wav", text: "ascii/112.wav" },
  { value: "ascii/113.wav", text: "ascii/113.wav" },
  { value: "ascii/114.wav", text: "ascii/114.wav" },
  { value: "ascii/115.wav", text: "ascii/115.wav" },
  { value: "ascii/116.wav", text: "ascii/116.wav" },
  { value: "ascii/117.wav", text: "ascii/117.wav" },
  { value: "ascii/118.wav", text: "ascii/118.wav" },
  { value: "ascii/119.wav", text: "ascii/119.wav" },
  { value: "ascii/120.wav", text: "ascii/120.wav" },
  { value: "ascii/121.wav", text: "ascii/121.wav" },
  { value: "ascii/122.wav", text: "ascii/122.wav" },
  { value: "ascii/123.wav", text: "ascii/123.wav" },
  { value: "ascii/124.wav", text: "ascii/124.wav" },
  { value: "ascii/125.wav", text: "ascii/125.wav" },
  { value: "ascii/126.wav", text: "ascii/126.wav" },
  { value: "ascii/32.wav", text: "ascii/32.wav" },
  { value: "ascii/33.wav", text: "ascii/33.wav" },
  { value: "ascii/34.wav", text: "ascii/34.wav" },
  { value: "ascii/35.wav", text: "ascii/35.wav" },
  { value: "ascii/36.wav", text: "ascii/36.wav" },
  { value: "ascii/37.wav", text: "ascii/37.wav" },
  { value: "ascii/38.wav", text: "ascii/38.wav" },
  { value: "ascii/39.wav", text: "ascii/39.wav" },
  { value: "ascii/40.wav", text: "ascii/40.wav" },
  { value: "ascii/41.wav", text: "ascii/41.wav" },
  { value: "ascii/42.wav", text: "ascii/42.wav" },
  { value: "ascii/43.wav", text: "ascii/43.wav" },
  { value: "ascii/44.wav", text: "ascii/44.wav" },
  { value: "ascii/45.wav", text: "ascii/45.wav" },
  { value: "ascii/46.wav", text: "ascii/46.wav" },
  { value: "ascii/47.wav", text: "ascii/47.wav" },
  { value: "ascii/58.wav", text: "ascii/58.wav" },
  { value: "ascii/59.wav", text: "ascii/59.wav" },
  { value: "ascii/60.wav", text: "ascii/60.wav" },
  { value: "ascii/61.wav", text: "ascii/61.wav" },
  { value: "ascii/62.wav", text: "ascii/62.wav" },
  { value: "ascii/64.wav", text: "ascii/64.wav" },
  { value: "ascii/91.wav", text: "ascii/91.wav" },
  { value: "ascii/92.wav", text: "ascii/92.wav" },
  { value: "ascii/93.wav", text: "ascii/93.wav" },
  { value: "ascii/94.wav", text: "ascii/94.wav" },
  { value: "ascii/95.wav", text: "ascii/95.wav" },
  { value: "ascii/96.wav", text: "ascii/96.wav" },
  { value: "ascii/97.wav", text: "ascii/97.wav" },
  { value: "ascii/98.wav", text: "ascii/98.wav" },
  { value: "ascii/99.wav", text: "ascii/99.wav" },
  { value: "base256/Algol.wav", text: "base256/Algol.wav" },
  { value: "base256/Apollo.wav", text: "base256/Apollo.wav" },
  { value: "base256/Athens.wav", text: "base256/Athens.wav" },
  { value: "base256/Atlantic.wav", text: "base256/Atlantic.wav" },
  { value: "base256/Aztec.wav", text: "base256/Aztec.wav" },
  { value: "base256/Babylon.wav", text: "base256/Babylon.wav" },
  { value: "base256/Belfast.wav", text: "base256/Belfast.wav" },
  { value: "base256/Bradbury.wav", text: "base256/Bradbury.wav" },
  { value: "base256/Brazilian.wav", text: "base256/Brazilian.wav" },
  { value: "base256/Burbank.wav", text: "base256/Burbank.wav" },
  { value: "base256/Burlington.wav", text: "base256/Burlington.wav" },
  { value: "base256/Camelot.wav", text: "base256/Camelot.wav" },
  { value: "base256/Capricorn.wav", text: "base256/Capricorn.wav" },
  { value: "base256/Cherokee.wav", text: "base256/Cherokee.wav" },
  { value: "base256/Chicago.wav", text: "base256/Chicago.wav" },
  { value: "base256/Christmas.wav", text: "base256/Christmas.wav" },
  { value: "base256/Dakota.wav", text: "base256/Dakota.wav" },
  { value: "base256/December.wav", text: "base256/December.wav" },
  { value: "base256/Dupont.wav", text: "base256/Dupont.wav" },
  { value: "base256/Eskimo.wav", text: "base256/Eskimo.wav" },
  { value: "base256/Galveston.wav", text: "base256/Galveston.wav" },
  { value: "base256/Geiger.wav", text: "base256/Geiger.wav" },
  { value: "base256/Hamilton.wav", text: "base256/Hamilton.wav" },
  { value: "base256/Istanbul.wav", text: "base256/Istanbul.wav" },
  { value: "base256/Jamaica.wav", text: "base256/Jamaica.wav" },
  { value: "base256/Jupiter.wav", text: "base256/Jupiter.wav" },
  { value: "base256/Medusa.wav", text: "base256/Medusa.wav" },
  { value: "base256/Mohawk.wav", text: "base256/Mohawk.wav" },
  { value: "base256/Montana.wav", text: "base256/Montana.wav" },
  { value: "base256/Neptune.wav", text: "base256/Neptune.wav" },
  { value: "base256/Norwegian.wav", text: "base256/Norwegian.wav" },
  { value: "base256/Oakland.wav", text: "base256/Oakland.wav" },
  { value: "base256/October.wav", text: "base256/October.wav" },
  { value: "base256/Ohio.wav", text: "base256/Ohio.wav" },
  { value: "base256/Orlando.wav", text: "base256/Orlando.wav" },
  { value: "base256/Pacific.wav", text: "base256/Pacific.wav" },
  { value: "base256/Pandora.wav", text: "base256/Pandora.wav" },
  { value: "base256/Pegasus.wav", text: "base256/Pegasus.wav" },
  { value: "base256/Pluto.wav", text: "base256/Pluto.wav" },
  { value: "base256/Saturday.wav", text: "base256/Saturday.wav" },
  { value: "base256/Scotland.wav", text: "base256/Scotland.wav" },
  { value: "base256/Trojan.wav", text: "base256/Trojan.wav" },
  { value: "base256/Virginia.wav", text: "base256/Virginia.wav" },
  { value: "base256/Vulcan.wav", text: "base256/Vulcan.wav" },
  { value: "base256/Waterloo.wav", text: "base256/Waterloo.wav" },
  { value: "base256/Wichita.wav", text: "base256/Wichita.wav" },
  { value: "base256/Wilmington.wav", text: "base256/Wilmington.wav" },
  { value: "base256/Wyoming.wav", text: "base256/Wyoming.wav" },
  { value: "base256/Yucatan.wav", text: "base256/Yucatan.wav" },
  { value: "base256/Zulu.wav", text: "base256/Zulu.wav" },
  { value: "base256/aardvark.wav", text: "base256/aardvark.wav" },
  { value: "base256/absurd.wav", text: "base256/absurd.wav" },
  { value: "base256/accrue.wav", text: "base256/accrue.wav" },
  { value: "base256/acme.wav", text: "base256/acme.wav" },
  { value: "base256/adrift.wav", text: "base256/adrift.wav" },
  { value: "base256/adroitness.wav", text: "base256/adroitness.wav" },
  { value: "base256/adult.wav", text: "base256/adult.wav" },
  { value: "base256/adviser.wav", text: "base256/adviser.wav" },
  { value: "base256/afflict.wav", text: "base256/afflict.wav" },
  { value: "base256/aftermath.wav", text: "base256/aftermath.wav" },
  { value: "base256/aggregate.wav", text: "base256/aggregate.wav" },
  { value: "base256/ahead.wav", text: "base256/ahead.wav" },
  { value: "base256/aimless.wav", text: "base256/aimless.wav" },
  { value: "base256/alkali.wav", text: "base256/alkali.wav" },
  { value: "base256/allow.wav", text: "base256/allow.wav" },
  { value: "base256/almighty.wav", text: "base256/almighty.wav" },
  { value: "base256/alone.wav", text: "base256/alone.wav" },
  { value: "base256/ammo.wav", text: "base256/ammo.wav" },
  { value: "base256/amulet.wav", text: "base256/amulet.wav" },
  { value: "base256/amusement.wav", text: "base256/amusement.wav" },
  { value: "base256/ancient.wav", text: "base256/ancient.wav" },
  { value: "base256/antenna.wav", text: "base256/antenna.wav" },
  { value: "base256/apple.wav", text: "base256/apple.wav" },
  { value: "base256/applicant.wav", text: "base256/applicant.wav" },
  { value: "base256/armistice.wav", text: "base256/armistice.wav" },
  { value: "base256/article.wav", text: "base256/article.wav" },
  { value: "base256/artist.wav", text: "base256/artist.wav" },
  { value: "base256/assume.wav", text: "base256/assume.wav" },
  { value: "base256/asteroid.wav", text: "base256/asteroid.wav" },
  { value: "base256/atlas.wav", text: "base256/atlas.wav" },
  { value: "base256/atmosphere.wav", text: "base256/atmosphere.wav" },
  { value: "base256/autopsy.wav", text: "base256/autopsy.wav" },
  { value: "base256/baboon.wav", text: "base256/baboon.wav" },
  { value: "base256/backfield.wav", text: "base256/backfield.wav" },
  { value: "base256/backward.wav", text: "base256/backward.wav" },
  { value: "base256/backwater.wav", text: "base256/backwater.wav" },
  { value: "base256/banjo.wav", text: "base256/banjo.wav" },
  { value: "base256/barbecue.wav", text: "base256/barbecue.wav" },
  { value: "base256/beaming.wav", text: "base256/beaming.wav" },
  { value: "base256/bedlamp.wav", text: "base256/bedlamp.wav" },
  { value: "base256/beehive.wav", text: "base256/beehive.wav" },
  { value: "base256/beeswax.wav", text: "base256/beeswax.wav" },
  { value: "base256/befriend.wav", text: "base256/befriend.wav" },
  { value: "base256/belowground.wav", text: "base256/belowground.wav" },
  { value: "base256/berserk.wav", text: "base256/berserk.wav" },
  { value: "base256/bifocals.wav", text: "base256/bifocals.wav" },
  { value: "base256/billiard.wav", text: "base256/billiard.wav" },
  { value: "base256/bison.wav", text: "base256/bison.wav" },
  { value: "base256/blackjack.wav", text: "base256/blackjack.wav" },
  { value: "base256/blockade.wav", text: "base256/blockade.wav" },
  { value: "base256/blowtorch.wav", text: "base256/blowtorch.wav" },
  { value: "base256/bluebird.wav", text: "base256/bluebird.wav" },
  { value: "base256/bodyguard.wav", text: "base256/bodyguard.wav" },
  { value: "base256/bombast.wav", text: "base256/bombast.wav" },
  { value: "base256/bookseller.wav", text: "base256/bookseller.wav" },
  { value: "base256/bookshelf.wav", text: "base256/bookshelf.wav" },
  { value: "base256/borderline.wav", text: "base256/borderline.wav" },
  { value: "base256/bottomless.wav", text: "base256/bottomless.wav" },
  { value: "base256/brackish.wav", text: "base256/brackish.wav" },
  { value: "base256/bravado.wav", text: "base256/bravado.wav" },
  { value: "base256/breadline.wav", text: "base256/breadline.wav" },
  { value: "base256/breakaway.wav", text: "base256/breakaway.wav" },
  { value: "base256/breakup.wav", text: "base256/breakup.wav" },
  { value: "base256/brickyard.wav", text: "base256/brickyard.wav" },
  { value: "base256/briefcase.wav", text: "base256/briefcase.wav" },
  { value: "base256/businessman.wav", text: "base256/businessman.wav" },
  { value: "base256/butterfat.wav", text: "base256/butterfat.wav" },
  { value: "base256/button.wav", text: "base256/button.wav" },
  { value: "base256/buzzard.wav", text: "base256/buzzard.wav" },
  { value: "base256/candidate.wav", text: "base256/candidate.wav" },
  { value: "base256/cannonball.wav", text: "base256/cannonball.wav" },
  { value: "base256/caravan.wav", text: "base256/caravan.wav" },
  { value: "base256/caretaker.wav", text: "base256/caretaker.wav" },
  { value: "base256/celebrate.wav", text: "base256/celebrate.wav" },
  { value: "base256/cellulose.wav", text: "base256/cellulose.wav" },
  { value: "base256/cement.wav", text: "base256/cement.wav" },
  { value: "base256/certify.wav", text: "base256/certify.wav" },
  { value: "base256/chairlift.wav", text: "base256/chairlift.wav" },
  { value: "base256/chambermaid.wav", text: "base256/chambermaid.wav" },
  { value: "base256/chatter.wav", text: "base256/chatter.wav" },
  { value: "base256/checkup.wav", text: "base256/checkup.wav" },
  { value: "base256/chisel.wav", text: "base256/chisel.wav" },
  { value: "base256/choking.wav", text: "base256/choking.wav" },
  { value: "base256/chopper.wav", text: "base256/chopper.wav" },
  { value: "base256/clamshell.wav", text: "base256/clamshell.wav" },
  { value: "base256/classic.wav", text: "base256/classic.wav" },
  { value: "base256/classroom.wav", text: "base256/classroom.wav" },
  { value: "base256/cleanup.wav", text: "base256/cleanup.wav" },
  { value: "base256/clergyman.wav", text: "base256/clergyman.wav" },
  { value: "base256/clockwork.wav", text: "base256/clockwork.wav" },
  { value: "base256/cobra.wav", text: "base256/cobra.wav" },
  { value: "base256/coherence.wav", text: "base256/coherence.wav" },
  { value: "base256/combustion.wav", text: "base256/combustion.wav" },
  { value: "base256/commando.wav", text: "base256/commando.wav" },
  { value: "base256/commence.wav", text: "base256/commence.wav" },
  { value: "base256/company.wav", text: "base256/company.wav" },
  { value: "base256/component.wav", text: "base256/component.wav" },
  { value: "base256/concert.wav", text: "base256/concert.wav" },
  { value: "base256/concurrent.wav", text: "base256/concurrent.wav" },
  { value: "base256/confidence.wav", text: "base256/confidence.wav" },
  { value: "base256/conformist.wav", text: "base256/conformist.wav" },
  { value: "base256/congregate.wav", text: "base256/congregate.wav" },
  { value: "base256/consensus.wav", text: "base256/consensus.wav" },
  { value: "base256/consulting.wav", text: "base256/consulting.wav" },
  { value: "base256/corporate.wav", text: "base256/corporate.wav" },
  { value: "base256/corrosion.wav", text: "base256/corrosion.wav" },
  { value: "base256/councilman.wav", text: "base256/councilman.wav" },
  { value: "base256/cowbell.wav", text: "base256/cowbell.wav" },
  { value: "base256/crackdown.wav", text: "base256/crackdown.wav" },
  { value: "base256/cranky.wav", text: "base256/cranky.wav" },
  { value: "base256/crossover.wav", text: "base256/crossover.wav" },
  { value: "base256/crowfoot.wav", text: "base256/crowfoot.wav" },
  { value: "base256/crucial.wav", text: "base256/crucial.wav" },
  { value: "base256/crucifix.wav", text: "base256/crucifix.wav" },
  { value: "base256/crumpled.wav", text: "base256/crumpled.wav" },
  { value: "base256/crusade.wav", text: "base256/crusade.wav" },
  { value: "base256/cubic.wav", text: "base256/cubic.wav" },
  { value: "base256/cumbersome.wav", text: "base256/cumbersome.wav" },
  { value: "base256/customer.wav", text: "base256/customer.wav" },
  { value: "base256/dashboard.wav", text: "base256/dashboard.wav" },
  { value: "base256/deadbolt.wav", text: "base256/deadbolt.wav" },
  { value: "base256/decadence.wav", text: "base256/decadence.wav" },
  { value: "base256/decimal.wav", text: "base256/decimal.wav" },
  { value: "base256/deckhand.wav", text: "base256/deckhand.wav" },
  { value: "base256/designing.wav", text: "base256/designing.wav" },
  { value: "base256/detector.wav", text: "base256/detector.wav" },
  { value: "base256/detergent.wav", text: "base256/detergent.wav" },
  { value: "base256/determine.wav", text: "base256/determine.wav" },
  { value: "base256/dictator.wav", text: "base256/dictator.wav" },
  { value: "base256/dinosaur.wav", text: "base256/dinosaur.wav" },
  { value: "base256/direction.wav", text: "base256/direction.wav" },
  { value: "base256/disable.wav", text: "base256/disable.wav" },
  { value: "base256/disbelief.wav", text: "base256/disbelief.wav" },
  { value: "base256/disruptive.wav", text: "base256/disruptive.wav" },
  { value: "base256/distortion.wav", text: "base256/distortion.wav" },
  { value: "base256/document.wav", text: "base256/document.wav" },
  { value: "base256/dogsled.wav", text: "base256/dogsled.wav" },
  { value: "base256/dragnet.wav", text: "base256/dragnet.wav" },
  { value: "base256/drainage.wav", text: "base256/drainage.wav" },
  { value: "base256/dreadful.wav", text: "base256/dreadful.wav" },
  { value: "base256/drifter.wav", text: "base256/drifter.wav" },
  { value: "base256/dropper.wav", text: "base256/dropper.wav" },
  { value: "base256/drumbeat.wav", text: "base256/drumbeat.wav" },
  { value: "base256/drunken.wav", text: "base256/drunken.wav" },
  { value: "base256/dwelling.wav", text: "base256/dwelling.wav" },
  { value: "base256/eating.wav", text: "base256/eating.wav" },
  { value: "base256/edict.wav", text: "base256/edict.wav" },
  { value: "base256/egghead.wav", text: "base256/egghead.wav" },
  { value: "base256/eightball.wav", text: "base256/eightball.wav" },
  { value: "base256/embezzle.wav", text: "base256/embezzle.wav" },
  { value: "base256/enchanting.wav", text: "base256/enchanting.wav" },
  { value: "base256/endorse.wav", text: "base256/endorse.wav" },
  { value: "base256/endow.wav", text: "base256/endow.wav" },
  { value: "base256/enlist.wav", text: "base256/enlist.wav" },
  { value: "base256/enrollment.wav", text: "base256/enrollment.wav" },
  { value: "base256/enterprise.wav", text: "base256/enterprise.wav" },
  { value: "base256/equation.wav", text: "base256/equation.wav" },
  { value: "base256/equipment.wav", text: "base256/equipment.wav" },
  { value: "base256/erase.wav", text: "base256/erase.wav" },
  { value: "base256/escapade.wav", text: "base256/escapade.wav" },
  { value: "base256/escape.wav", text: "base256/escape.wav" },
  { value: "base256/everyday.wav", text: "base256/everyday.wav" },
  { value: "base256/examine.wav", text: "base256/examine.wav" },
  { value: "base256/exceed.wav", text: "base256/exceed.wav" },
  { value: "base256/existence.wav", text: "base256/existence.wav" },
  { value: "base256/exodus.wav", text: "base256/exodus.wav" },
  { value: "base256/eyeglass.wav", text: "base256/eyeglass.wav" },
  { value: "base256/eyetooth.wav", text: "base256/eyetooth.wav" },
  { value: "base256/facial.wav", text: "base256/facial.wav" },
  { value: "base256/fallout.wav", text: "base256/fallout.wav" },
  { value: "base256/fascinate.wav", text: "base256/fascinate.wav" },
  { value: "base256/filament.wav", text: "base256/filament.wav" },
  { value: "base256/finicky.wav", text: "base256/finicky.wav" },
  { value: "base256/flagpole.wav", text: "base256/flagpole.wav" },
  { value: "base256/flatfoot.wav", text: "base256/flatfoot.wav" },
  { value: "base256/flytrap.wav", text: "base256/flytrap.wav" },
  { value: "base256/forever.wav", text: "base256/forever.wav" },
  { value: "base256/fortitude.wav", text: "base256/fortitude.wav" },
  { value: "base256/fracture.wav", text: "base256/fracture.wav" },
  { value: "base256/framework.wav", text: "base256/framework.wav" },
  { value: "base256/freedom.wav", text: "base256/freedom.wav" },
  { value: "base256/frequency.wav", text: "base256/frequency.wav" },
  { value: "base256/frighten.wav", text: "base256/frighten.wav" },
  { value: "base256/gadgetry.wav", text: "base256/gadgetry.wav" },
  { value: "base256/gazelle.wav", text: "base256/gazelle.wav" },
  { value: "base256/getaway.wav", text: "base256/getaway.wav" },
  { value: "base256/glitter.wav", text: "base256/glitter.wav" },
  { value: "base256/glossary.wav", text: "base256/glossary.wav" },
  { value: "base256/glucose.wav", text: "base256/glucose.wav" },
  { value: "base256/goggles.wav", text: "base256/goggles.wav" },
  { value: "base256/goldfish.wav", text: "base256/goldfish.wav" },
  { value: "base256/gossamer.wav", text: "base256/gossamer.wav" },
  { value: "base256/graduate.wav", text: "base256/graduate.wav" },
  { value: "base256/gravity.wav", text: "base256/gravity.wav" },
  { value: "base256/gremlin.wav", text: "base256/gremlin.wav" },
  { value: "base256/guidance.wav", text: "base256/guidance.wav" },
  { value: "base256/guitarist.wav", text: "base256/guitarist.wav" },
  { value: "base256/hamburger.wav", text: "base256/hamburger.wav" },
  { value: "base256/hamlet.wav", text: "base256/hamlet.wav" },
  { value: "base256/handiwork.wav", text: "base256/handiwork.wav" },
  { value: "base256/hazardous.wav", text: "base256/hazardous.wav" },
  { value: "base256/headwaters.wav", text: "base256/headwaters.wav" },
  { value: "base256/hemisphere.wav", text: "base256/hemisphere.wav" },
  { value: "base256/hesitate.wav", text: "base256/hesitate.wav" },
  { value: "base256/hideaway.wav", text: "base256/hideaway.wav" },
  { value: "base256/highchair.wav", text: "base256/highchair.wav" },
  { value: "base256/hockey.wav", text: "base256/hockey.wav" },
  { value: "base256/holiness.wav", text: "base256/holiness.wav" },
  { value: "base256/hurricane.wav", text: "base256/hurricane.wav" },
  { value: "base256/hydraulic.wav", text: "base256/hydraulic.wav" },
  { value: "base256/impartial.wav", text: "base256/impartial.wav" },
  { value: "base256/impetus.wav", text: "base256/impetus.wav" },
  { value: "base256/inception.wav", text: "base256/inception.wav" },
  { value: "base256/indigo.wav", text: "base256/indigo.wav" },
  { value: "base256/indoors.wav", text: "base256/indoors.wav" },
  { value: "base256/indulge.wav", text: "base256/indulge.wav" },
  { value: "base256/inertia.wav", text: "base256/inertia.wav" },
  { value: "base256/infancy.wav", text: "base256/infancy.wav" },
  { value: "base256/inferno.wav", text: "base256/inferno.wav" },
  { value: "base256/informant.wav", text: "base256/informant.wav" },
  { value: "base256/insincere.wav", text: "base256/insincere.wav" },
  { value: "base256/insurgent.wav", text: "base256/insurgent.wav" },
  { value: "base256/integrate.wav", text: "base256/integrate.wav" },
  { value: "base256/intention.wav", text: "base256/intention.wav" },
  { value: "base256/inventive.wav", text: "base256/inventive.wav" },
  { value: "base256/inverse.wav", text: "base256/inverse.wav" },
  { value: "base256/involve.wav", text: "base256/involve.wav" },
  { value: "base256/island.wav", text: "base256/island.wav" },
  { value: "base256/jawbone.wav", text: "base256/jawbone.wav" },
  { value: "base256/keyboard.wav", text: "base256/keyboard.wav" },
  { value: "base256/kickoff.wav", text: "base256/kickoff.wav" },
  { value: "base256/kiwi.wav", text: "base256/kiwi.wav" },
  { value: "base256/klaxon.wav", text: "base256/klaxon.wav" },
  { value: "base256/leprosy.wav", text: "base256/leprosy.wav" },
  { value: "base256/letterhead.wav", text: "base256/letterhead.wav" },
  { value: "base256/liberty.wav", text: "base256/liberty.wav" },
  { value: "base256/locale.wav", text: "base256/locale.wav" },
  { value: "base256/lockup.wav", text: "base256/lockup.wav" },
  { value: "base256/maritime.wav", text: "base256/maritime.wav" },
  { value: "base256/matchmaker.wav", text: "base256/matchmaker.wav" },
  { value: "base256/maverick.wav", text: "base256/maverick.wav" },
  { value: "base256/megaton.wav", text: "base256/megaton.wav" },
  { value: "base256/merit.wav", text: "base256/merit.wav" },
  { value: "base256/microscope.wav", text: "base256/microscope.wav" },
  { value: "base256/microwave.wav", text: "base256/microwave.wav" },
  { value: "base256/midsummer.wav", text: "base256/midsummer.wav" },
  { value: "base256/millionaire.wav", text: "base256/millionaire.wav" },
  { value: "base256/minnow.wav", text: "base256/minnow.wav" },
  { value: "base256/miracle.wav", text: "base256/miracle.wav" },
  { value: "base256/miser.wav", text: "base256/miser.wav" },
  { value: "base256/misnomer.wav", text: "base256/misnomer.wav" },
  { value: "base256/molasses.wav", text: "base256/molasses.wav" },
  { value: "base256/molecule.wav", text: "base256/molecule.wav" },
  { value: "base256/monument.wav", text: "base256/monument.wav" },
  { value: "base256/mosquito.wav", text: "base256/mosquito.wav" },
  { value: "base256/mural.wav", text: "base256/mural.wav" },
  { value: "base256/music.wav", text: "base256/music.wav" },
  { value: "base256/narrative.wav", text: "base256/narrative.wav" },
  { value: "base256/nebula.wav", text: "base256/nebula.wav" },
  { value: "base256/necklace.wav", text: "base256/necklace.wav" },
  { value: "base256/newborn.wav", text: "base256/newborn.wav" },
  { value: "base256/newsletter.wav", text: "base256/newsletter.wav" },
  { value: "base256/nightbird.wav", text: "base256/nightbird.wav" },
  { value: "base256/obtuse.wav", text: "base256/obtuse.wav" },
  { value: "base256/offload.wav", text: "base256/offload.wav" },
  { value: "base256/onlooker.wav", text: "base256/onlooker.wav" },
  { value: "base256/optic.wav", text: "base256/optic.wav" },
  { value: "base256/opulent.wav", text: "base256/opulent.wav" },
  { value: "base256/orca.wav", text: "base256/orca.wav" },
  { value: "base256/outfielder.wav", text: "base256/outfielder.wav" },
  { value: "base256/pandemic.wav", text: "base256/pandemic.wav" },
  { value: "base256/paperweight.wav", text: "base256/paperweight.wav" },
  { value: "base256/paragon.wav", text: "base256/paragon.wav" },
  { value: "base256/paragraph.wav", text: "base256/paragraph.wav" },
  { value: "base256/paramount.wav", text: "base256/paramount.wav" },
  { value: "base256/passenger.wav", text: "base256/passenger.wav" },
  { value: "base256/payday.wav", text: "base256/payday.wav" },
  { value: "base256/peachy.wav", text: "base256/peachy.wav" },
  { value: "base256/pedigree.wav", text: "base256/pedigree.wav" },
  { value: "base256/penetrate.wav", text: "base256/penetrate.wav" },
  { value: "base256/perceptive.wav", text: "base256/perceptive.wav" },
  { value: "base256/performance.wav", text: "base256/performance.wav" },
  { value: "base256/pharmacy.wav", text: "base256/pharmacy.wav" },
  { value: "base256/pheasant.wav", text: "base256/pheasant.wav" },
  { value: "base256/phonetic.wav", text: "base256/phonetic.wav" },
  { value: "base256/photograph.wav", text: "base256/photograph.wav" },
  { value: "base256/physique.wav", text: "base256/physique.wav" },
  { value: "base256/pioneer.wav", text: "base256/pioneer.wav" },
  { value: "base256/playhouse.wav", text: "base256/playhouse.wav" },
  { value: "base256/pocketful.wav", text: "base256/pocketful.wav" },
  { value: "base256/politeness.wav", text: "base256/politeness.wav" },
  { value: "base256/positive.wav", text: "base256/positive.wav" },
  { value: "base256/potato.wav", text: "base256/potato.wav" },
  { value: "base256/preclude.wav", text: "base256/preclude.wav" },
  { value: "base256/prefer.wav", text: "base256/prefer.wav" },
  { value: "base256/preshrunk.wav", text: "base256/preshrunk.wav" },
  { value: "base256/printer.wav", text: "base256/printer.wav" },
  { value: "base256/processor.wav", text: "base256/processor.wav" },
  { value: "base256/provincial.wav", text: "base256/provincial.wav" },
  { value: "base256/prowler.wav", text: "base256/prowler.wav" },
  { value: "base256/proximate.wav", text: "base256/proximate.wav" },
  { value: "base256/puberty.wav", text: "base256/puberty.wav" },
  { value: "base256/publisher.wav", text: "base256/publisher.wav" },
  { value: "base256/pupil.wav", text: "base256/pupil.wav" },
  { value: "base256/puppy.wav", text: "base256/puppy.wav" },
  { value: "base256/pyramid.wav", text: "base256/pyramid.wav" },
  { value: "base256/python.wav", text: "base256/python.wav" },
  { value: "base256/quadrant.wav", text: "base256/quadrant.wav" },
  { value: "base256/quantity.wav", text: "base256/quantity.wav" },
  { value: "base256/quiver.wav", text: "base256/quiver.wav" },
  { value: "base256/quota.wav", text: "base256/quota.wav" },
  { value: "base256/racketeer.wav", text: "base256/racketeer.wav" },
  { value: "base256/ragtime.wav", text: "base256/ragtime.wav" },
  { value: "base256/ratchet.wav", text: "base256/ratchet.wav" },
  { value: "base256/rebellion.wav", text: "base256/rebellion.wav" },
  { value: "base256/rebirth.wav", text: "base256/rebirth.wav" },
  { value: "base256/recipe.wav", text: "base256/recipe.wav" },
  { value: "base256/recover.wav", text: "base256/recover.wav" },
  { value: "base256/reform.wav", text: "base256/reform.wav" },
  { value: "base256/regain.wav", text: "base256/regain.wav" },
  { value: "base256/reindeer.wav", text: "base256/reindeer.wav" },
  { value: "base256/rematch.wav", text: "base256/rematch.wav" },
  { value: "base256/repay.wav", text: "base256/repay.wav" },
  { value: "base256/repellent.wav", text: "base256/repellent.wav" },
  { value: "base256/replica.wav", text: "base256/replica.wav" },
  { value: "base256/reproduce.wav", text: "base256/reproduce.wav" },
  { value: "base256/resistor.wav", text: "base256/resistor.wav" },
  { value: "base256/responsive.wav", text: "base256/responsive.wav" },
  { value: "base256/retouch.wav", text: "base256/retouch.wav" },
  { value: "base256/retraction.wav", text: "base256/retraction.wav" },
  { value: "base256/retrieval.wav", text: "base256/retrieval.wav" },
  { value: "base256/retrospect.wav", text: "base256/retrospect.wav" },
  { value: "base256/revenge.wav", text: "base256/revenge.wav" },
  { value: "base256/revenue.wav", text: "base256/revenue.wav" },
  { value: "base256/revival.wav", text: "base256/revival.wav" },
  { value: "base256/revolver.wav", text: "base256/revolver.wav" },
  { value: "base256/reward.wav", text: "base256/reward.wav" },
  { value: "base256/rhythm.wav", text: "base256/rhythm.wav" },
  { value: "base256/ribcage.wav", text: "base256/ribcage.wav" },
  { value: "base256/ringbolt.wav", text: "base256/ringbolt.wav" },
  { value: "base256/robust.wav", text: "base256/robust.wav" },
  { value: "base256/rocker.wav", text: "base256/rocker.wav" },
  { value: "base256/ruffled.wav", text: "base256/ruffled.wav" },
  { value: "base256/sailboat.wav", text: "base256/sailboat.wav" },
  { value: "base256/sandalwood.wav", text: "base256/sandalwood.wav" },
  { value: "base256/sardonic.wav", text: "base256/sardonic.wav" },
  { value: "base256/savagery.wav", text: "base256/savagery.wav" },
  { value: "base256/sawdust.wav", text: "base256/sawdust.wav" },
  { value: "base256/scallion.wav", text: "base256/scallion.wav" },
  { value: "base256/scavenger.wav", text: "base256/scavenger.wav" },
  { value: "base256/scenic.wav", text: "base256/scenic.wav" },
  { value: "base256/scorecard.wav", text: "base256/scorecard.wav" },
  { value: "base256/seabird.wav", text: "base256/seabird.wav" },
  { value: "base256/select.wav", text: "base256/select.wav" },
  { value: "base256/sensation.wav", text: "base256/sensation.wav" },
  { value: "base256/sentence.wav", text: "base256/sentence.wav" },
  { value: "base256/shadow.wav", text: "base256/shadow.wav" },
  { value: "base256/shamrock.wav", text: "base256/shamrock.wav" },
  { value: "base256/showgirl.wav", text: "base256/showgirl.wav" },
  { value: "base256/skullcap.wav", text: "base256/skullcap.wav" },
  { value: "base256/skydive.wav", text: "base256/skydive.wav" },
  { value: "base256/slingshot.wav", text: "base256/slingshot.wav" },
  { value: "base256/slowdown.wav", text: "base256/slowdown.wav" },
  { value: "base256/snapline.wav", text: "base256/snapline.wav" },
  { value: "base256/snapshot.wav", text: "base256/snapshot.wav" },
  { value: "base256/snowcap.wav", text: "base256/snowcap.wav" },
  { value: "base256/snowslide.wav", text: "base256/snowslide.wav" },
  { value: "base256/sociable.wav", text: "base256/sociable.wav" },
  { value: "base256/solo.wav", text: "base256/solo.wav" },
  { value: "base256/southward.wav", text: "base256/southward.wav" },
  { value: "base256/souvenir.wav", text: "base256/souvenir.wav" },
  { value: "base256/soybean.wav", text: "base256/soybean.wav" },
  { value: "base256/spaniel.wav", text: "base256/spaniel.wav" },
  { value: "base256/spearhead.wav", text: "base256/spearhead.wav" },
  { value: "base256/specialist.wav", text: "base256/specialist.wav" },
  { value: "base256/speculate.wav", text: "base256/speculate.wav" },
  { value: "base256/spellbind.wav", text: "base256/spellbind.wav" },
  { value: "base256/spheroid.wav", text: "base256/spheroid.wav" },
  { value: "base256/spigot.wav", text: "base256/spigot.wav" },
  { value: "base256/spindle.wav", text: "base256/spindle.wav" },
  { value: "base256/spyglass.wav", text: "base256/spyglass.wav" },
  { value: "base256/stagehand.wav", text: "base256/stagehand.wav" },
  { value: "base256/stagnate.wav", text: "base256/stagnate.wav" },
  { value: "base256/stairway.wav", text: "base256/stairway.wav" },
  { value: "base256/standard.wav", text: "base256/standard.wav" },
  { value: "base256/stapler.wav", text: "base256/stapler.wav" },
  { value: "base256/steamship.wav", text: "base256/steamship.wav" },
  { value: "base256/sterling.wav", text: "base256/sterling.wav" },
  { value: "base256/stethoscope.wav", text: "base256/stethoscope.wav" },
  { value: "base256/stockman.wav", text: "base256/stockman.wav" },
  { value: "base256/stopwatch.wav", text: "base256/stopwatch.wav" },
  { value: "base256/stormy.wav", text: "base256/stormy.wav" },
  { value: "base256/stupendous.wav", text: "base256/stupendous.wav" },
  { value: "base256/sugar.wav", text: "base256/sugar.wav" },
  { value: "base256/supportive.wav", text: "base256/supportive.wav" },
  { value: "base256/surmount.wav", text: "base256/surmount.wav" },
  { value: "base256/surrender.wav", text: "base256/surrender.wav" },
  { value: "base256/suspense.wav", text: "base256/suspense.wav" },
  { value: "base256/suspicious.wav", text: "base256/suspicious.wav" },
  { value: "base256/sweatband.wav", text: "base256/sweatband.wav" },
  { value: "base256/swelter.wav", text: "base256/swelter.wav" },
  { value: "base256/sympathy.wav", text: "base256/sympathy.wav" },
  { value: "base256/tactics.wav", text: "base256/tactics.wav" },
  { value: "base256/talon.wav", text: "base256/talon.wav" },
  { value: "base256/tambourine.wav", text: "base256/tambourine.wav" },
  { value: "base256/tapeworm.wav", text: "base256/tapeworm.wav" },
  { value: "base256/telephone.wav", text: "base256/telephone.wav" },
  { value: "base256/tempest.wav", text: "base256/tempest.wav" },
  { value: "base256/therapist.wav", text: "base256/therapist.wav" },
  { value: "base256/tiger.wav", text: "base256/tiger.wav" },
  { value: "base256/tissue.wav", text: "base256/tissue.wav" },
  { value: "base256/tobacco.wav", text: "base256/tobacco.wav" },
  { value: "base256/tolerance.wav", text: "base256/tolerance.wav" },
  { value: "base256/tomorrow.wav", text: "base256/tomorrow.wav" },
  { value: "base256/tonic.wav", text: "base256/tonic.wav" },
  { value: "base256/topmost.wav", text: "base256/topmost.wav" },
  { value: "base256/torpedo.wav", text: "base256/torpedo.wav" },
  { value: "base256/tracker.wav", text: "base256/tracker.wav" },
  { value: "base256/tradition.wav", text: "base256/tradition.wav" },
  { value: "base256/transit.wav", text: "base256/transit.wav" },
  { value: "base256/trauma.wav", text: "base256/trauma.wav" },
  { value: "base256/travesty.wav", text: "base256/travesty.wav" },
  { value: "base256/treadmill.wav", text: "base256/treadmill.wav" },
  { value: "base256/trombonist.wav", text: "base256/trombonist.wav" },
  { value: "base256/trouble.wav", text: "base256/trouble.wav" },
  { value: "base256/truncated.wav", text: "base256/truncated.wav" },
  { value: "base256/tumor.wav", text: "base256/tumor.wav" },
  { value: "base256/tunnel.wav", text: "base256/tunnel.wav" },
  { value: "base256/tycoon.wav", text: "base256/tycoon.wav" },
  { value: "base256/typewriter.wav", text: "base256/typewriter.wav" },
  { value: "base256/ultimate.wav", text: "base256/ultimate.wav" },
  { value: "base256/uncut.wav", text: "base256/uncut.wav" },
  { value: "base256/undaunted.wav", text: "base256/undaunted.wav" },
  { value: "base256/underfoot.wav", text: "base256/underfoot.wav" },
  { value: "base256/unearth.wav", text: "base256/unearth.wav" },
  { value: "base256/unicorn.wav", text: "base256/unicorn.wav" },
  { value: "base256/unify.wav", text: "base256/unify.wav" },
  { value: "base256/universe.wav", text: "base256/universe.wav" },
  { value: "base256/unravel.wav", text: "base256/unravel.wav" },
  { value: "base256/unwind.wav", text: "base256/unwind.wav" },
  { value: "base256/upcoming.wav", text: "base256/upcoming.wav" },
  { value: "base256/uproot.wav", text: "base256/uproot.wav" },
  { value: "base256/upset.wav", text: "base256/upset.wav" },
  { value: "base256/upshot.wav", text: "base256/upshot.wav" },
  { value: "base256/vacancy.wav", text: "base256/vacancy.wav" },
  { value: "base256/vagabond.wav", text: "base256/vagabond.wav" },
  { value: "base256/vapor.wav", text: "base256/vapor.wav" },
  { value: "base256/vertigo.wav", text: "base256/vertigo.wav" },
  { value: "base256/village.wav", text: "base256/village.wav" },
  { value: "base256/virus.wav", text: "base256/virus.wav" },
  { value: "base256/visitor.wav", text: "base256/visitor.wav" },
  { value: "base256/vocalist.wav", text: "base256/vocalist.wav" },
  { value: "base256/voyager.wav", text: "base256/voyager.wav" },
  { value: "base256/waffle.wav", text: "base256/waffle.wav" },
  { value: "base256/wallet.wav", text: "base256/wallet.wav" },
  { value: "base256/warranty.wav", text: "base256/warranty.wav" },
  { value: "base256/watchword.wav", text: "base256/watchword.wav" },
  { value: "base256/wayside.wav", text: "base256/wayside.wav" },
  { value: "base256/whimsical.wav", text: "base256/whimsical.wav" },
  { value: "base256/willow.wav", text: "base256/willow.wav" },
  { value: "base256/woodlark.wav", text: "base256/woodlark.wav" },
  { value: "base256/yesteryear.wav", text: "base256/yesteryear.wav" },
  { value: "conference/conf-alone.wav", text: "conference/conf-alone.wav" },
  { value: "conference/conf-bad-pin.wav", text: "conference/conf-bad-pin.wav" },
  {
    value: "conference/conf-conference_is_full.wav",
    text: "conference/conf-conference_is_full.wav",
  },
  {
    value: "conference/conf-conference_is_in_qna_mode.wav",
    text: "conference/conf-conference_is_in_qna_mode.wav",
  },
  {
    value: "conference/conf-conference_will_start_shortly.wav",
    text: "conference/conf-conference_will_start_shortly.wav",
  },
  {
    value: "conference/conf-enter_conf_number.wav",
    text: "conference/conf-enter_conf_number.wav",
  },
  {
    value: "conference/conf-enter_conf_pin.wav",
    text: "conference/conf-enter_conf_pin.wav",
  },
  {
    value: "conference/conf-entry_sound.wav",
    text: "conference/conf-entry_sound.wav",
  },
  {
    value: "conference/conf-exit_sound.wav",
    text: "conference/conf-exit_sound.wav",
  },
  { value: "conference/conf-goodbye.wav", text: "conference/conf-goodbye.wav" },
  {
    value: "conference/conf-has_joined.wav",
    text: "conference/conf-has_joined.wav",
  },
  {
    value: "conference/conf-has_left.wav",
    text: "conference/conf-has_left.wav",
  },
  {
    value: "conference/conf-is-locked.wav",
    text: "conference/conf-is-locked.wav",
  },
  {
    value: "conference/conf-is-unlocked.wav",
    text: "conference/conf-is-unlocked.wav",
  },
  { value: "conference/conf-kicked.wav", text: "conference/conf-kicked.wav" },
  {
    value: "conference/conf-listener_in_conference.wav",
    text: "conference/conf-listener_in_conference.wav",
  },
  {
    value: "conference/conf-listeners_in_conference.wav",
    text: "conference/conf-listeners_in_conference.wav",
  },
  { value: "conference/conf-locked.wav", text: "conference/conf-locked.wav" },
  {
    value: "conference/conf-members_in_conference.wav",
    text: "conference/conf-members_in_conference.wav",
  },
  { value: "conference/conf-muted.wav", text: "conference/conf-muted.wav" },
  {
    value: "conference/conf-number_of_listeners.wav",
    text: "conference/conf-number_of_listeners.wav",
  },
  {
    value: "conference/conf-one_other_member_conference.wav",
    text: "conference/conf-one_other_member_conference.wav",
  },
  {
    value: "conference/conf-one_other_person_conference.wav",
    text: "conference/conf-one_other_person_conference.wav",
  },
  {
    value: "conference/conf-other_persons_conference.wav",
    text: "conference/conf-other_persons_conference.wav",
  },
  { value: "conference/conf-pin.wav", text: "conference/conf-pin.wav" },
  {
    value: "conference/conf-qna_mode.wav",
    text: "conference/conf-qna_mode.wav",
  },
  { value: "conference/conf-unmuted.wav", text: "conference/conf-unmuted.wav" },
  { value: "conference/conf-welcome.wav", text: "conference/conf-welcome.wav" },
  {
    value: "conference/conf-you_are_already_muted.wav",
    text: "conference/conf-you_are_already_muted.wav",
  },
  {
    value: "conference/conf-you_are_now_bidirectionally_muted.wav",
    text: "conference/conf-you_are_now_bidirectionally_muted.wav",
  },
  { value: "currency/and.wav", text: "currency/and.wav" },
  { value: "currency/cent.wav", text: "currency/cent.wav" },
  { value: "currency/central.wav", text: "currency/central.wav" },
  {
    value: "currency/cents-per-minute.wav",
    text: "currency/cents-per-minute.wav",
  },
  { value: "currency/cents.wav", text: "currency/cents.wav" },
  { value: "currency/dollar.wav", text: "currency/dollar.wav" },
  { value: "currency/dollars.wav", text: "currency/dollars.wav" },
  { value: "currency/minus.wav", text: "currency/minus.wav" },
  { value: "currency/negative.wav", text: "currency/negative.wav" },
  { value: "digits/0.wav", text: "digits/0.wav" },
  { value: "digits/1.wav", text: "digits/1.wav" },
  { value: "digits/10.wav", text: "digits/10.wav" },
  { value: "digits/11.wav", text: "digits/11.wav" },
  { value: "digits/12.wav", text: "digits/12.wav" },
  { value: "digits/13.wav", text: "digits/13.wav" },
  { value: "digits/14.wav", text: "digits/14.wav" },
  { value: "digits/15.wav", text: "digits/15.wav" },
  { value: "digits/16.wav", text: "digits/16.wav" },
  { value: "digits/17.wav", text: "digits/17.wav" },
  { value: "digits/18.wav", text: "digits/18.wav" },
  { value: "digits/19.wav", text: "digits/19.wav" },
  { value: "digits/2.wav", text: "digits/2.wav" },
  { value: "digits/20.wav", text: "digits/20.wav" },
  { value: "digits/3.wav", text: "digits/3.wav" },
  { value: "digits/30.wav", text: "digits/30.wav" },
  { value: "digits/4.wav", text: "digits/4.wav" },
  { value: "digits/40.wav", text: "digits/40.wav" },
  { value: "digits/5.wav", text: "digits/5.wav" },
  { value: "digits/50.wav", text: "digits/50.wav" },
  { value: "digits/6.wav", text: "digits/6.wav" },
  { value: "digits/60.wav", text: "digits/60.wav" },
  { value: "digits/7.wav", text: "digits/7.wav" },
  { value: "digits/70.wav", text: "digits/70.wav" },
  { value: "digits/8.wav", text: "digits/8.wav" },
  { value: "digits/80.wav", text: "digits/80.wav" },
  { value: "digits/9.wav", text: "digits/9.wav" },
  { value: "digits/90.wav", text: "digits/90.wav" },
  { value: "digits/dot.wav", text: "digits/dot.wav" },
  { value: "digits/h-1.wav", text: "digits/h-1.wav" },
  { value: "digits/h-10.wav", text: "digits/h-10.wav" },
  { value: "digits/h-11.wav", text: "digits/h-11.wav" },
  { value: "digits/h-12.wav", text: "digits/h-12.wav" },
  { value: "digits/h-13.wav", text: "digits/h-13.wav" },
  { value: "digits/h-14.wav", text: "digits/h-14.wav" },
  { value: "digits/h-15.wav", text: "digits/h-15.wav" },
  { value: "digits/h-16.wav", text: "digits/h-16.wav" },
  { value: "digits/h-17.wav", text: "digits/h-17.wav" },
  { value: "digits/h-18.wav", text: "digits/h-18.wav" },
  { value: "digits/h-19.wav", text: "digits/h-19.wav" },
  { value: "digits/h-2.wav", text: "digits/h-2.wav" },
  { value: "digits/h-20.wav", text: "digits/h-20.wav" },
  { value: "digits/h-3.wav", text: "digits/h-3.wav" },
  { value: "digits/h-30.wav", text: "digits/h-30.wav" },
  { value: "digits/h-4.wav", text: "digits/h-4.wav" },
  { value: "digits/h-5.wav", text: "digits/h-5.wav" },
  { value: "digits/h-6.wav", text: "digits/h-6.wav" },
  { value: "digits/h-7.wav", text: "digits/h-7.wav" },
  { value: "digits/h-8.wav", text: "digits/h-8.wav" },
  { value: "digits/h-9.wav", text: "digits/h-9.wav" },
  { value: "digits/hundred.wav", text: "digits/hundred.wav" },
  { value: "digits/million.wav", text: "digits/million.wav" },
  { value: "digits/period.wav", text: "digits/period.wav" },
  { value: "digits/point.wav", text: "digits/point.wav" },
  { value: "digits/pound.wav", text: "digits/pound.wav" },
  { value: "digits/star.wav", text: "digits/star.wav" },
  { value: "digits/thousand.wav", text: "digits/thousand.wav" },
  {
    value: "directory/dir-at_extension.wav",
    text: "directory/dir-at_extension.wav",
  },
  {
    value: "directory/dir-enter_person.wav",
    text: "directory/dir-enter_person.wav",
  },
  {
    value: "directory/dir-enter_person_first_or_last.wav",
    text: "directory/dir-enter_person_first_or_last.wav",
  },
  {
    value: "directory/dir-first_name.wav",
    text: "directory/dir-first_name.wav",
  },
  { value: "directory/dir-for_next.wav", text: "directory/dir-for_next.wav" },
  { value: "directory/dir-for_prev.wav", text: "directory/dir-for_prev.wav" },
  { value: "directory/dir-last_name.wav", text: "directory/dir-last_name.wav" },
  {
    value: "directory/dir-letters_of_person_name.wav",
    text: "directory/dir-letters_of_person_name.wav",
  },
  {
    value: "directory/dir-no_matching_results.wav",
    text: "directory/dir-no_matching_results.wav",
  },
  {
    value: "directory/dir-no_more_results.wav",
    text: "directory/dir-no_more_results.wav",
  },
  {
    value: "directory/dir-please_try_again.wav",
    text: "directory/dir-please_try_again.wav",
  },
  {
    value: "directory/dir-result_match.wav",
    text: "directory/dir-result_match.wav",
  },
  {
    value: "directory/dir-result_number.wav",
    text: "directory/dir-result_number.wav",
  },
  {
    value: "directory/dir-specify_mininum.wav",
    text: "directory/dir-specify_mininum.wav",
  },
  {
    value: "directory/dir-start_new_search.wav",
    text: "directory/dir-start_new_search.wav",
  },
  {
    value: "directory/dir-to_search_by.wav",
    text: "directory/dir-to_search_by.wav",
  },
  {
    value: "directory/dir-to_select_entry.wav",
    text: "directory/dir-to_select_entry.wav",
  },
  {
    value: "directory/dir-too_many_result.wav",
    text: "directory/dir-too_many_result.wav",
  },
  { value: "ivr/ivr-accept_reject.wav", text: "ivr/ivr-accept_reject.wav" },
  {
    value: "ivr/ivr-accept_reject_voicemail.wav",
    text: "ivr/ivr-accept_reject_voicemail.wav",
  },
  { value: "ivr/ivr-access_denied.wav", text: "ivr/ivr-access_denied.wav" },
  {
    value: "ivr/ivr-account_balance_is.wav",
    text: "ivr/ivr-account_balance_is.wav",
  },
  { value: "ivr/ivr-account_number.wav", text: "ivr/ivr-account_number.wav" },
  {
    value: "ivr/ivr-aint_nobody_got_time_for_that.wav",
    text: "ivr/ivr-aint_nobody_got_time_for_that.wav",
  },
  {
    value: "ivr/ivr-all_your_call_are_belong_to_us.wav",
    text: "ivr/ivr-all_your_call_are_belong_to_us.wav",
  },
  {
    value: "ivr/ivr-already_contains_a_recording.wav",
    text: "ivr/ivr-already_contains_a_recording.wav",
  },
  {
    value: "ivr/ivr-anonymous_caller.wav",
    text: "ivr/ivr-anonymous_caller.wav",
  },
  { value: "ivr/ivr-any_other_digit.wav", text: "ivr/ivr-any_other_digit.wav" },
  {
    value: "ivr/ivr-appointment_schedule_for.wav",
    text: "ivr/ivr-appointment_schedule_for.wav",
  },
  {
    value: "ivr/ivr-asterisk_like_syphilis.wav",
    text: "ivr/ivr-asterisk_like_syphilis.wav",
  },
  { value: "ivr/ivr-at_the_tone.wav", text: "ivr/ivr-at_the_tone.wav" },
  {
    value: "ivr/ivr-automated_attendant.wav",
    text: "ivr/ivr-automated_attendant.wav",
  },
  {
    value: "ivr/ivr-automated_attendants.wav",
    text: "ivr/ivr-automated_attendants.wav",
  },
  { value: "ivr/ivr-barbecuing.wav", text: "ivr/ivr-barbecuing.wav" },
  {
    value: "ivr/ivr-barracuda_networks.wav",
    text: "ivr/ivr-barracuda_networks.wav",
  },
  { value: "ivr/ivr-beacuase.wav", text: "ivr/ivr-beacuase.wav" },
  { value: "ivr/ivr-begin_recording.wav", text: "ivr/ivr-begin_recording.wav" },
  { value: "ivr/ivr-by_dialing.wav", text: "ivr/ivr-by_dialing.wav" },
  { value: "ivr/ivr-call.wav", text: "ivr/ivr-call.wav" },
  {
    value: "ivr/ivr-call_answered_order_received.wav",
    text: "ivr/ivr-call_answered_order_received.wav",
  },
  {
    value: "ivr/ivr-call_attempt_aborted.wav",
    text: "ivr/ivr-call_attempt_aborted.wav",
  },
  {
    value: "ivr/ivr-call_being_transferred.wav",
    text: "ivr/ivr-call_being_transferred.wav",
  },
  {
    value: "ivr/ivr-call_cannot_be_completed_as_dialed.wav",
    text: "ivr/ivr-call_cannot_be_completed_as_dialed.wav",
  },
  {
    value: "ivr/ivr-call_forwarding_has_been_cancelled.wav",
    text: "ivr/ivr-call_forwarding_has_been_cancelled.wav",
  },
  {
    value: "ivr/ivr-call_forwarding_has_been_set.wav",
    text: "ivr/ivr-call_forwarding_has_been_set.wav",
  },
  { value: "ivr/ivr-call_from.wav", text: "ivr/ivr-call_from.wav" },
  { value: "ivr/ivr-call_rejected.wav", text: "ivr/ivr-call_rejected.wav" },
  {
    value: "ivr/ivr-call_screening_disabled.wav",
    text: "ivr/ivr-call_screening_disabled.wav",
  },
  {
    value: "ivr/ivr-call_screening_enabled.wav",
    text: "ivr/ivr-call_screening_enabled.wav",
  },
  {
    value: "ivr/ivr-cancel_wakeup_call.wav",
    text: "ivr/ivr-cancel_wakeup_call.wav",
  },
  { value: "ivr/ivr-cold_foolish.wav", text: "ivr/ivr-cold_foolish.wav" },
  { value: "ivr/ivr-cold_pop.wav", text: "ivr/ivr-cold_pop.wav" },
  { value: "ivr/ivr-concentrate.wav", text: "ivr/ivr-concentrate.wav" },
  {
    value: "ivr/ivr-congratulations_you_pressed_star.wav",
    text: "ivr/ivr-congratulations_you_pressed_star.wav",
  },
  {
    value: "ivr/ivr-connect_actual_human_being.wav",
    text: "ivr/ivr-connect_actual_human_being.wav",
  },
  {
    value: "ivr/ivr-connect_to_caller.wav",
    text: "ivr/ivr-connect_to_caller.wav",
  },
  {
    value: "ivr/ivr-contact_system_administrator.wav",
    text: "ivr/ivr-contact_system_administrator.wav",
  },
  {
    value: "ivr/ivr-credit_card_could_not_be_charged.wav",
    text: "ivr/ivr-credit_card_could_not_be_charged.wav",
  },
  {
    value: "ivr/ivr-cudatel_communication_server.wav",
    text: "ivr/ivr-cudatel_communication_server.wav",
  },
  {
    value: "ivr/ivr-custom_mode_number.wav",
    text: "ivr/ivr-custom_mode_number.wav",
  },
  {
    value: "ivr/ivr-customer_service.wav",
    text: "ivr/ivr-customer_service.wav",
  },
  {
    value: "ivr/ivr-daily_wakeup_call.wav",
    text: "ivr/ivr-daily_wakeup_call.wav",
  },
  { value: "ivr/ivr-day_mode.wav", text: "ivr/ivr-day_mode.wav" },
  {
    value: "ivr/ivr-delayed_echo_your_audio_back.wav",
    text: "ivr/ivr-delayed_echo_your_audio_back.wav",
  },
  {
    value: "ivr/ivr-did_you_mean_to_press_key.wav",
    text: "ivr/ivr-did_you_mean_to_press_key.wav",
  },
  { value: "ivr/ivr-disabled.wav", text: "ivr/ivr-disabled.wav" },
  { value: "ivr/ivr-dnd_activated.wav", text: "ivr/ivr-dnd_activated.wav" },
  { value: "ivr/ivr-dnd_cancelled.wav", text: "ivr/ivr-dnd_cancelled.wav" },
  {
    value: "ivr/ivr-do_not_call_list.wav",
    text: "ivr/ivr-do_not_call_list.wav",
  },
  {
    value: "ivr/ivr-does_not_contain_a_recording.wav",
    text: "ivr/ivr-does_not_contain_a_recording.wav",
  },
  { value: "ivr/ivr-douche_telecom.wav", text: "ivr/ivr-douche_telecom.wav" },
  { value: "ivr/ivr-dude_you_suck.wav", text: "ivr/ivr-dude_you_suck.wav" },
  {
    value: "ivr/ivr-echo_your_audio_back.wav",
    text: "ivr/ivr-echo_your_audio_back.wav",
  },
  { value: "ivr/ivr-enabled.wav", text: "ivr/ivr-enabled.wav" },
  {
    value: "ivr/ivr-engineers_busy_assisting_other_sales.wav",
    text: "ivr/ivr-engineers_busy_assisting_other_sales.wav",
  },
  {
    value: "ivr/ivr-enjoy_music_while_transfer.wav",
    text: "ivr/ivr-enjoy_music_while_transfer.wav",
  },
  {
    value: "ivr/ivr-ensure_service_keeps_working.wav",
    text: "ivr/ivr-ensure_service_keeps_working.wav",
  },
  {
    value: "ivr/ivr-enter_destination_telephone_number.wav",
    text: "ivr/ivr-enter_destination_telephone_number.wav",
  },
  { value: "ivr/ivr-enter_ext.wav", text: "ivr/ivr-enter_ext.wav" },
  { value: "ivr/ivr-enter_ext_pound.wav", text: "ivr/ivr-enter_ext_pound.wav" },
  {
    value: "ivr/ivr-enter_number_send_fax.wav",
    text: "ivr/ivr-enter_number_send_fax.wav",
  },
  {
    value: "ivr/ivr-enter_number_to_add_to_blacklist.wav",
    text: "ivr/ivr-enter_number_to_add_to_blacklist.wav",
  },
  {
    value: "ivr/ivr-enter_number_to_remove_from_blacklist.wav",
    text: "ivr/ivr-enter_number_to_remove_from_blacklist.wav",
  },
  {
    value: "ivr/ivr-enter_queue_number.wav",
    text: "ivr/ivr-enter_queue_number.wav",
  },
  {
    value: "ivr/ivr-enter_source_telephone_number.wav",
    text: "ivr/ivr-enter_source_telephone_number.wav",
  },
  {
    value: "ivr/ivr-estimated_hold_time.wav",
    text: "ivr/ivr-estimated_hold_time.wav",
  },
  {
    value: "ivr/ivr-exit_sound_prompt.wav",
    text: "ivr/ivr-exit_sound_prompt.wav",
  },
  {
    value: "ivr/ivr-extension_number.wav",
    text: "ivr/ivr-extension_number.wav",
  },
  {
    value: "ivr/ivr-extension_to_provision_this_phone.wav",
    text: "ivr/ivr-extension_to_provision_this_phone.wav",
  },
  {
    value: "ivr/ivr-failure_reason_is.wav",
    text: "ivr/ivr-failure_reason_is.wav",
  },
  { value: "ivr/ivr-feature.wav", text: "ivr/ivr-feature.wav" },
  { value: "ivr/ivr-file.wav", text: "ivr/ivr-file.wav" },
  { value: "ivr/ivr-file_a_jira.wav", text: "ivr/ivr-file_a_jira.wav" },
  { value: "ivr/ivr-files.wav", text: "ivr/ivr-files.wav" },
  {
    value: "ivr/ivr-finished_pound_hash_key.wav",
    text: "ivr/ivr-finished_pound_hash_key.wav",
  },
  {
    value: "ivr/ivr-first_name_first.wav",
    text: "ivr/ivr-first_name_first.wav",
  },
  {
    value: "ivr/ivr-followed_by_pound.wav",
    text: "ivr/ivr-followed_by_pound.wav",
  },
  { value: "ivr/ivr-for.wav", text: "ivr/ivr-for.wav" },
  {
    value: "ivr/ivr-for_a_wakeup_call.wav",
    text: "ivr/ivr-for_a_wakeup_call.wav",
  },
  {
    value: "ivr/ivr-for_daily_wakeup_call.wav",
    text: "ivr/ivr-for_daily_wakeup_call.wav",
  },
  {
    value: "ivr/ivr-for_daily_wakeup_calls.wav",
    text: "ivr/ivr-for_daily_wakeup_calls.wav",
  },
  {
    value: "ivr/ivr-for_directory_press.wav",
    text: "ivr/ivr-for_directory_press.wav",
  },
  {
    value: "ivr/ivr-for_english_press.wav",
    text: "ivr/ivr-for_english_press.wav",
  },
  {
    value: "ivr/ivr-for_one_time_wakeup_call.wav",
    text: "ivr/ivr-for_one_time_wakeup_call.wav",
  },
  {
    value: "ivr/ivr-for_other_options.wav",
    text: "ivr/ivr-for_other_options.wav",
  },
  { value: "ivr/ivr-for_this_person.wav", text: "ivr/ivr-for_this_person.wav" },
  {
    value: "ivr/ivr-founder_of_freesource.wav",
    text: "ivr/ivr-founder_of_freesource.wav",
  },
  { value: "ivr/ivr-freeguipy.wav", text: "ivr/ivr-freeguipy.wav" },
  { value: "ivr/ivr-gateway_down.wav", text: "ivr/ivr-gateway_down.wav" },
  {
    value: "ivr/ivr-generic_greeting.wav",
    text: "ivr/ivr-generic_greeting.wav",
  },
  { value: "ivr/ivr-good_afternoon.wav", text: "ivr/ivr-good_afternoon.wav" },
  { value: "ivr/ivr-good_evening.wav", text: "ivr/ivr-good_evening.wav" },
  { value: "ivr/ivr-good_morning.wav", text: "ivr/ivr-good_morning.wav" },
  { value: "ivr/ivr-got_bronchitis.wav", text: "ivr/ivr-got_bronchitis.wav" },
  { value: "ivr/ivr-hang_up.wav", text: "ivr/ivr-hang_up.wav" },
  {
    value: "ivr/ivr-hangup_to_discard.wav",
    text: "ivr/ivr-hangup_to_discard.wav",
  },
  {
    value: "ivr/ivr-hangup_to_end_test.wav",
    text: "ivr/ivr-hangup_to_end_test.wav",
  },
  {
    value: "ivr/ivr-has_been_added_to_the_blacklist.wav",
    text: "ivr/ivr-has_been_added_to_the_blacklist.wav",
  },
  {
    value: "ivr/ivr-has_been_answered.wav",
    text: "ivr/ivr-has_been_answered.wav",
  },
  {
    value: "ivr/ivr-has_been_removed.wav",
    text: "ivr/ivr-has_been_removed.wav",
  },
  {
    value: "ivr/ivr-has_been_removed_from_blacklist.wav",
    text: "ivr/ivr-has_been_removed_from_blacklist.wav",
  },
  {
    value: "ivr/ivr-has_called_emergency_services.wav",
    text: "ivr/ivr-has_called_emergency_services.wav",
  },
  { value: "ivr/ivr-has_had.wav", text: "ivr/ivr-has_had.wav" },
  {
    value: "ivr/ivr-has_left_the_building.wav",
    text: "ivr/ivr-has_left_the_building.wav",
  },
  {
    value: "ivr/ivr-hear_usage_stats.wav",
    text: "ivr/ivr-hear_usage_stats.wav",
  },
  { value: "ivr/ivr-hello.wav", text: "ivr/ivr-hello.wav" },
  {
    value: "ivr/ivr-hold_connect_call.wav",
    text: "ivr/ivr-hold_connect_call.wav",
  },
  { value: "ivr/ivr-hotseat_intro.wav", text: "ivr/ivr-hotseat_intro.wav" },
  { value: "ivr/ivr-hotseat_options.wav", text: "ivr/ivr-hotseat_options.wav" },
  { value: "ivr/ivr-hotseat_pin.wav", text: "ivr/ivr-hotseat_pin.wav" },
  { value: "ivr/ivr-id_number.wav", text: "ivr/ivr-id_number.wav" },
  {
    value: "ivr/ivr-if_correct_one_if_not_two.wav",
    text: "ivr/ivr-if_correct_one_if_not_two.wav",
  },
  {
    value: "ivr/ivr-if_correct_press.wav",
    text: "ivr/ivr-if_correct_press.wav",
  },
  { value: "ivr/ivr-if_not_press.wav", text: "ivr/ivr-if_not_press.wav" },
  {
    value: "ivr/ivr-if_you_would_like_us_to_call_back.wav",
    text: "ivr/ivr-if_you_would_like_us_to_call_back.wav",
  },
  { value: "ivr/ivr-im_sorry.wav", text: "ivr/ivr-im_sorry.wav" },
  { value: "ivr/ivr-in_line.wav", text: "ivr/ivr-in_line.wav" },
  { value: "ivr/ivr-incoming_call.wav", text: "ivr/ivr-incoming_call.wav" },
  {
    value: "ivr/ivr-incompatible_destination.wav",
    text: "ivr/ivr-incompatible_destination.wav",
  },
  {
    value: "ivr/ivr-invalid_extension_try_again.wav",
    text: "ivr/ivr-invalid_extension_try_again.wav",
  },
  {
    value: "ivr/ivr-invalid_number_format.wav",
    text: "ivr/ivr-invalid_number_format.wav",
  },
  {
    value: "ivr/ivr-invalid_sound_prompt.wav",
    text: "ivr/ivr-invalid_sound_prompt.wav",
  },
  {
    value: "ivr/ivr-is_already_on_the_blacklist.wav",
    text: "ivr/ivr-is_already_on_the_blacklist.wav",
  },
  {
    value: "ivr/ivr-is_not_on_the_blacklist.wav",
    text: "ivr/ivr-is_not_on_the_blacklist.wav",
  },
  { value: "ivr/ivr-is_now_off.wav", text: "ivr/ivr-is_now_off.wav" },
  { value: "ivr/ivr-is_now_on.wav", text: "ivr/ivr-is_now_on.wav" },
  {
    value: "ivr/ivr-it_appears_that_your_phone_number_is.wav",
    text: "ivr/ivr-it_appears_that_your_phone_number_is.wav",
  },
  { value: "ivr/ivr-it_was_that_bug.wav", text: "ivr/ivr-it_was_that_bug.wav" },
  { value: "ivr/ivr-key.wav", text: "ivr/ivr-key.wav" },
  { value: "ivr/ivr-last_name_first.wav", text: "ivr/ivr-last_name_first.wav" },
  {
    value: "ivr/ivr-learn_more_freeguipydotorg.wav",
    text: "ivr/ivr-learn_more_freeguipydotorg.wav",
  },
  { value: "ivr/ivr-less_than.wav", text: "ivr/ivr-less_than.wav" },
  {
    value: "ivr/ivr-longer_than_usual_hold_times.wav",
    text: "ivr/ivr-longer_than_usual_hold_times.wav",
  },
  {
    value: "ivr/ivr-love_those_touch_tones.wav",
    text: "ivr/ivr-love_those_touch_tones.wav",
  },
  { value: "ivr/ivr-lunch_mode.wav", text: "ivr/ivr-lunch_mode.wav" },
  {
    value: "ivr/ivr-message_self_destruct.wav",
    text: "ivr/ivr-message_self_destruct.wav",
  },
  {
    value: "ivr/ivr-modify_main_prompt.wav",
    text: "ivr/ivr-modify_main_prompt.wav",
  },
  {
    value: "ivr/ivr-modify_main_prompts.wav",
    text: "ivr/ivr-modify_main_prompts.wav",
  },
  {
    value: "ivr/ivr-modify_option_prompts.wav",
    text: "ivr/ivr-modify_option_prompts.wav",
  },
  { value: "ivr/ivr-more_than.wav", text: "ivr/ivr-more_than.wav" },
  {
    value: "ivr/ivr-next_billing_cycle.wav",
    text: "ivr/ivr-next_billing_cycle.wav",
  },
  { value: "ivr/ivr-night_mode.wav", text: "ivr/ivr-night_mode.wav" },
  {
    value: "ivr/ivr-no_calls_waiting_in_queue.wav",
    text: "ivr/ivr-no_calls_waiting_in_queue.wav",
  },
  {
    value: "ivr/ivr-no_longer_in_queue.wav",
    text: "ivr/ivr-no_longer_in_queue.wav",
  },
  { value: "ivr/ivr-no_menu_items.wav", text: "ivr/ivr-no_menu_items.wav" },
  { value: "ivr/ivr-no_no_no.wav", text: "ivr/ivr-no_no_no.wav" },
  {
    value: "ivr/ivr-no_questions_in_queue.wav",
    text: "ivr/ivr-no_questions_in_queue.wav",
  },
  {
    value: "ivr/ivr-no_route_destination.wav",
    text: "ivr/ivr-no_route_destination.wav",
  },
  { value: "ivr/ivr-no_shoes.wav", text: "ivr/ivr-no_shoes.wav" },
  {
    value: "ivr/ivr-no_user_response.wav",
    text: "ivr/ivr-no_user_response.wav",
  },
  {
    value: "ivr/ivr-nobody_got_time_for_that.wav",
    text: "ivr/ivr-nobody_got_time_for_that.wav",
  },
  { value: "ivr/ivr-normal_clearing.wav", text: "ivr/ivr-normal_clearing.wav" },
  {
    value: "ivr/ivr-normal_unspecified.wav",
    text: "ivr/ivr-normal_unspecified.wav",
  },
  { value: "ivr/ivr-not.wav", text: "ivr/ivr-not.wav" },
  {
    value: "ivr/ivr-not_accept_anonymous_calls.wav",
    text: "ivr/ivr-not_accept_anonymous_calls.wav",
  },
  {
    value: "ivr/ivr-not_have_permission.wav",
    text: "ivr/ivr-not_have_permission.wav",
  },
  {
    value: "ivr/ivr-not_have_permission_to_edit.wav",
    text: "ivr/ivr-not_have_permission_to_edit.wav",
  },
  {
    value: "ivr/ivr-not_requested_wakeup_call.wav",
    text: "ivr/ivr-not_requested_wakeup_call.wav",
  },
  { value: "ivr/ivr-number.wav", text: "ivr/ivr-number.wav" },
  { value: "ivr/ivr-oh_whatever.wav", text: "ivr/ivr-oh_whatever.wav" },
  {
    value: "ivr/ivr-on_hold_indefinitely.wav",
    text: "ivr/ivr-on_hold_indefinitely.wav",
  },
  {
    value: "ivr/ivr-one_moment_please.wav",
    text: "ivr/ivr-one_moment_please.wav",
  },
  {
    value: "ivr/ivr-one_more_mistake.wav",
    text: "ivr/ivr-one_more_mistake.wav",
  },
  {
    value: "ivr/ivr-one_time_wakeup_call.wav",
    text: "ivr/ivr-one_time_wakeup_call.wav",
  },
  { value: "ivr/ivr-one_yes_two_no.wav", text: "ivr/ivr-one_yes_two_no.wav" },
  { value: "ivr/ivr-operator.wav", text: "ivr/ivr-operator.wav" },
  { value: "ivr/ivr-option.wav", text: "ivr/ivr-option.wav" },
  { value: "ivr/ivr-or.wav", text: "ivr/ivr-or.wav" },
  { value: "ivr/ivr-or_press.wav", text: "ivr/ivr-or_press.wav" },
  { value: "ivr/ivr-out_of.wav", text: "ivr/ivr-out_of.wav" },
  { value: "ivr/ivr-per_minute.wav", text: "ivr/ivr-per_minute.wav" },
  {
    value: "ivr/ivr-perform_delayed_echo_test.wav",
    text: "ivr/ivr-perform_delayed_echo_test.wav",
  },
  {
    value: "ivr/ivr-perform_dtmf_test.wav",
    text: "ivr/ivr-perform_dtmf_test.wav",
  },
  {
    value: "ivr/ivr-perform_echo_test.wav",
    text: "ivr/ivr-perform_echo_test.wav",
  },
  {
    value: "ivr/ivr-phone_is_configured_properly.wav",
    text: "ivr/ivr-phone_is_configured_properly.wav",
  },
  {
    value: "ivr/ivr-phone_is_unassigned.wav",
    text: "ivr/ivr-phone_is_unassigned.wav",
  },
  {
    value: "ivr/ivr-phone_not_configured.wav",
    text: "ivr/ivr-phone_not_configured.wav",
  },
  {
    value: "ivr/ivr-phone_not_make_external_calls.wav",
    text: "ivr/ivr-phone_not_make_external_calls.wav",
  },
  {
    value: "ivr/ivr-pin_or_extension_is-invalid.wav",
    text: "ivr/ivr-pin_or_extension_is-invalid.wav",
  },
  { value: "ivr/ivr-please.wav", text: "ivr/ivr-please.wav" },
  {
    value: "ivr/ivr-please_check_number_try_again.wav",
    text: "ivr/ivr-please_check_number_try_again.wav",
  },
  { value: "ivr/ivr-please_contact.wav", text: "ivr/ivr-please_contact.wav" },
  {
    value: "ivr/ivr-please_enjoy_music_while_party_reached.wav",
    text: "ivr/ivr-please_enjoy_music_while_party_reached.wav",
  },
  {
    value: "ivr/ivr-please_enter_extension_followed_by_pound.wav",
    text: "ivr/ivr-please_enter_extension_followed_by_pound.wav",
  },
  {
    value: "ivr/ivr-please_enter_extension_number_of.wav",
    text: "ivr/ivr-please_enter_extension_number_of.wav",
  },
  {
    value: "ivr/ivr-please_enter_pin_followed_by_pound.wav",
    text: "ivr/ivr-please_enter_pin_followed_by_pound.wav",
  },
  {
    value: "ivr/ivr-please_enter_the.wav",
    text: "ivr/ivr-please_enter_the.wav",
  },
  {
    value: "ivr/ivr-please_enter_the_number_where_we_can_reach_you.wav",
    text: "ivr/ivr-please_enter_the_number_where_we_can_reach_you.wav",
  },
  {
    value: "ivr/ivr-please_enter_the_phone_number.wav",
    text: "ivr/ivr-please_enter_the_phone_number.wav",
  },
  {
    value: "ivr/ivr-please_hold_while_party_contacted.wav",
    text: "ivr/ivr-please_hold_while_party_contacted.wav",
  },
  {
    value: "ivr/ivr-please_reenter_your_pin.wav",
    text: "ivr/ivr-please_reenter_your_pin.wav",
  },
  {
    value: "ivr/ivr-please_return_our_call_at.wav",
    text: "ivr/ivr-please_return_our_call_at.wav",
  },
  {
    value: "ivr/ivr-please_state_your_name_and_reason_for_calling.wav",
    text: "ivr/ivr-please_state_your_name_and_reason_for_calling.wav",
  },
  {
    value: "ivr/ivr-please_try_again.wav",
    text: "ivr/ivr-please_try_again.wav",
  },
  {
    value: "ivr/ivr-press_key_of_prompt_to_modify.wav",
    text: "ivr/ivr-press_key_of_prompt_to_modify.wav",
  },
  {
    value: "ivr/ivr-press_one_q_or_z.wav",
    text: "ivr/ivr-press_one_q_or_z.wav",
  },
  { value: "ivr/ivr-prompt.wav", text: "ivr/ivr-prompt.wav" },
  {
    value: "ivr/ivr-provision_phone_permanently_to_extension.wav",
    text: "ivr/ivr-provision_phone_permanently_to_extension.wav",
  },
  { value: "ivr/ivr-question.wav", text: "ivr/ivr-question.wav" },
  { value: "ivr/ivr-questions.wav", text: "ivr/ivr-questions.wav" },
  {
    value: "ivr/ivr-read_each_key_press_back.wav",
    text: "ivr/ivr-read_each_key_press_back.wav",
  },
  {
    value: "ivr/ivr-record_exit_sound.wav",
    text: "ivr/ivr-record_exit_sound.wav",
  },
  {
    value: "ivr/ivr-record_invalid_sound.wav",
    text: "ivr/ivr-record_invalid_sound.wav",
  },
  { value: "ivr/ivr-record_prompt.wav", text: "ivr/ivr-record_prompt.wav" },
  {
    value: "ivr/ivr-record_short_greeting.wav",
    text: "ivr/ivr-record_short_greeting.wav",
  },
  {
    value: "ivr/ivr-recording_deleted.wav",
    text: "ivr/ivr-recording_deleted.wav",
  },
  {
    value: "ivr/ivr-recording_paused.wav",
    text: "ivr/ivr-recording_paused.wav",
  },
  { value: "ivr/ivr-recording_saved.wav", text: "ivr/ivr-recording_saved.wav" },
  {
    value: "ivr/ivr-recording_started.wav",
    text: "ivr/ivr-recording_started.wav",
  },
  {
    value: "ivr/ivr-recording_stopped.wav",
    text: "ivr/ivr-recording_stopped.wav",
  },
  {
    value: "ivr/ivr-regarding_reference_number.wav",
    text: "ivr/ivr-regarding_reference_number.wav",
  },
  {
    value: "ivr/ivr-register_for_cluecon.wav",
    text: "ivr/ivr-register_for_cluecon.wav",
  },
  { value: "ivr/ivr-reminder_for.wav", text: "ivr/ivr-reminder_for.wav" },
  {
    value: "ivr/ivr-repeat_this_information.wav",
    text: "ivr/ivr-repeat_this_information.wav",
  },
  {
    value: "ivr/ivr-request_or_use_pin.wav",
    text: "ivr/ivr-request_or_use_pin.wav",
  },
  {
    value: "ivr/ivr-request_wakeup_call.wav",
    text: "ivr/ivr-request_wakeup_call.wav",
  },
  {
    value: "ivr/ivr-requested_wakeup_call_for.wav",
    text: "ivr/ivr-requested_wakeup_call_for.wav",
  },
  {
    value: "ivr/ivr-reset_usage_totals.wav",
    text: "ivr/ivr-reset_usage_totals.wav",
  },
  {
    value: "ivr/ivr-reset_usage_totals_confirm.wav",
    text: "ivr/ivr-reset_usage_totals_confirm.wav",
  },
  { value: "ivr/ivr-sales.wav", text: "ivr/ivr-sales.wav" },
  { value: "ivr/ivr-sample_submenu.wav", text: "ivr/ivr-sample_submenu.wav" },
  {
    value: "ivr/ivr-save_review_record.wav",
    text: "ivr/ivr-save_review_record.wav",
  },
  { value: "ivr/ivr-say_name.wav", text: "ivr/ivr-say_name.wav" },
  { value: "ivr/ivr-send_fax.wav", text: "ivr/ivr-send_fax.wav" },
  { value: "ivr/ivr-send_fax_now.wav", text: "ivr/ivr-send_fax_now.wav" },
  {
    value: "ivr/ivr-send_to_voicemail.wav",
    text: "ivr/ivr-send_to_voicemail.wav",
  },
  {
    value: "ivr/ivr-seriously_mean_to_press_key.wav",
    text: "ivr/ivr-seriously_mean_to_press_key.wav",
  },
  { value: "ivr/ivr-short_greeting.wav", text: "ivr/ivr-short_greeting.wav" },
  {
    value: "ivr/ivr-skip_instructions.wav",
    text: "ivr/ivr-skip_instructions.wav",
  },
  { value: "ivr/ivr-smoke_got_you.wav", text: "ivr/ivr-smoke_got_you.wav" },
  {
    value: "ivr/ivr-speak_to_a_customer_service_representative.wav",
    text: "ivr/ivr-speak_to_a_customer_service_representative.wav",
  },
  { value: "ivr/ivr-spell_name.wav", text: "ivr/ivr-spell_name.wav" },
  {
    value: "ivr/ivr-stay_on_line_call_answered_momentarily.wav",
    text: "ivr/ivr-stay_on_line_call_answered_momentarily.wav",
  },
  { value: "ivr/ivr-suck.wav", text: "ivr/ivr-suck.wav" },
  { value: "ivr/ivr-sucks.wav", text: "ivr/ivr-sucks.wav" },
  {
    value: "ivr/ivr-system_back_up_in_approximately.wav",
    text: "ivr/ivr-system_back_up_in_approximately.wav",
  },
  {
    value: "ivr/ivr-system_down_for_maintenance.wav",
    text: "ivr/ivr-system_down_for_maintenance.wav",
  },
  { value: "ivr/ivr-take_a_message.wav", text: "ivr/ivr-take_a_message.wav" },
  {
    value: "ivr/ivr-technical_support.wav",
    text: "ivr/ivr-technical_support.wav",
  },
  {
    value: "ivr/ivr-terribly_wrong_awkward.wav",
    text: "ivr/ivr-terribly_wrong_awkward.wav",
  },
  { value: "ivr/ivr-thank_you.wav", text: "ivr/ivr-thank_you.wav" },
  {
    value: "ivr/ivr-thank_you_for_calling.wav",
    text: "ivr/ivr-thank_you_for_calling.wav",
  },
  {
    value: "ivr/ivr-thank_you_for_holding.wav",
    text: "ivr/ivr-thank_you_for_holding.wav",
  },
  {
    value: "ivr/ivr-that_was_an_invalid_entry.wav",
    text: "ivr/ivr-that_was_an_invalid_entry.wav",
  },
  {
    value: "ivr/ivr-that_you_would_like_to_modify.wav",
    text: "ivr/ivr-that_you_would_like_to_modify.wav",
  },
  {
    value: "ivr/ivr-the_billing_department.wav",
    text: "ivr/ivr-the_billing_department.wav",
  },
  { value: "ivr/ivr-there_are.wav", text: "ivr/ivr-there_are.wav" },
  { value: "ivr/ivr-there_is.wav", text: "ivr/ivr-there_is.wav" },
  { value: "ivr/ivr-this_feature.wav", text: "ivr/ivr-this_feature.wav" },
  {
    value: "ivr/ivr-this_is_a_call_from.wav",
    text: "ivr/ivr-this_is_a_call_from.wav",
  },
  {
    value: "ivr/ivr-this_is_your_wakeup_call.wav",
    text: "ivr/ivr-this_is_your_wakeup_call.wav",
  },
  {
    value: "ivr/ivr-this_ivr_will_let_you_test_features.wav",
    text: "ivr/ivr-this_ivr_will_let_you_test_features.wav",
  },
  {
    value: "ivr/ivr-this_phone_will_now_reboot.wav",
    text: "ivr/ivr-this_phone_will_now_reboot.wav",
  },
  { value: "ivr/ivr-to_accept_press.wav", text: "ivr/ivr-to_accept_press.wav" },
  {
    value: "ivr/ivr-to_accept_press_one.wav",
    text: "ivr/ivr-to_accept_press_one.wav",
  },
  {
    value: "ivr/ivr-to_call_the_freeswitch_conference.wav",
    text: "ivr/ivr-to_call_the_freeswitch_conference.wav",
  },
  { value: "ivr/ivr-to_confirm.wav", text: "ivr/ivr-to_confirm.wav" },
  {
    value: "ivr/ivr-to_do_a_freeswitch_echo_test.wav",
    text: "ivr/ivr-to_do_a_freeswitch_echo_test.wav",
  },
  {
    value: "ivr/ivr-to_do_a_fwd_echo_test.wav",
    text: "ivr/ivr-to_do_a_fwd_echo_test.wav",
  },
  {
    value: "ivr/ivr-to_hear_sample_submenu.wav",
    text: "ivr/ivr-to_hear_sample_submenu.wav",
  },
  {
    value: "ivr/ivr-to_hear_screaming_monkeys.wav",
    text: "ivr/ivr-to_hear_screaming_monkeys.wav",
  },
  {
    value: "ivr/ivr-to_learn_more_about_freeswitch.wav",
    text: "ivr/ivr-to_learn_more_about_freeswitch.wav",
  },
  {
    value: "ivr/ivr-to_listen_to_moh.wav",
    text: "ivr/ivr-to_listen_to_moh.wav",
  },
  { value: "ivr/ivr-to_log_in.wav", text: "ivr/ivr-to_log_in.wav" },
  { value: "ivr/ivr-to_log_out.wav", text: "ivr/ivr-to_log_out.wav" },
  { value: "ivr/ivr-to_modify.wav", text: "ivr/ivr-to_modify.wav" },
  {
    value: "ivr/ivr-to_redial_last_call.wav",
    text: "ivr/ivr-to_redial_last_call.wav",
  },
  { value: "ivr/ivr-to_reject.wav", text: "ivr/ivr-to_reject.wav" },
  {
    value: "ivr/ivr-to_reject_hangup.wav",
    text: "ivr/ivr-to_reject_hangup.wav",
  },
  {
    value: "ivr/ivr-to_repeat_these_options.wav",
    text: "ivr/ivr-to_repeat_these_options.wav",
  },
  {
    value: "ivr/ivr-to_return_to_previous_menu.wav",
    text: "ivr/ivr-to_return_to_previous_menu.wav",
  },
  { value: "ivr/ivr-to_skip.wav", text: "ivr/ivr-to_skip.wav" },
  {
    value: "ivr/ivr-to_speak_with_an_operator.wav",
    text: "ivr/ivr-to_speak_with_an_operator.wav",
  },
  {
    value: "ivr/ivr-to_wait_stay_on_the_line.wav",
    text: "ivr/ivr-to_wait_stay_on_the_line.wav",
  },
  {
    value: "ivr/ivr-trollover_minutes.wav",
    text: "ivr/ivr-trollover_minutes.wav",
  },
  { value: "ivr/ivr-unable_save.wav", text: "ivr/ivr-unable_save.wav" },
  {
    value: "ivr/ivr-unallocated_number.wav",
    text: "ivr/ivr-unallocated_number.wav",
  },
  {
    value: "ivr/ivr-unblock_caller_id.wav",
    text: "ivr/ivr-unblock_caller_id.wav",
  },
  { value: "ivr/ivr-units.wav", text: "ivr/ivr-units.wav" },
  {
    value: "ivr/ivr-usage_totals_have_been_reset.wav",
    text: "ivr/ivr-usage_totals_have_been_reset.wav",
  },
  {
    value: "ivr/ivr-use_telephone_keypad.wav",
    text: "ivr/ivr-use_telephone_keypad.wav",
  },
  { value: "ivr/ivr-user_busy.wav", text: "ivr/ivr-user_busy.wav" },
  {
    value: "ivr/ivr-using_telephone_keypad.wav",
    text: "ivr/ivr-using_telephone_keypad.wav",
  },
  { value: "ivr/ivr-visitor.wav", text: "ivr/ivr-visitor.wav" },
  { value: "ivr/ivr-visitors.wav", text: "ivr/ivr-visitors.wav" },
  { value: "ivr/ivr-wakeup_call.wav", text: "ivr/ivr-wakeup_call.wav" },
  {
    value: "ivr/ivr-wakeup_call_cancelled.wav",
    text: "ivr/ivr-wakeup_call_cancelled.wav",
  },
  {
    value: "ivr/ivr-wakey_wakey_sunshine.wav",
    text: "ivr/ivr-wakey_wakey_sunshine.wav",
  },
  {
    value: "ivr/ivr-we_will_return_your_call_at_this_number.wav",
    text: "ivr/ivr-we_will_return_your_call_at_this_number.wav",
  },
  {
    value: "ivr/ivr-we_would_support.wav",
    text: "ivr/ivr-we_would_support.wav",
  },
  { value: "ivr/ivr-welcome.wav", text: "ivr/ivr-welcome.wav" },
  { value: "ivr/ivr-welcome_to.wav", text: "ivr/ivr-welcome_to.wav" },
  {
    value: "ivr/ivr-welcome_to_freeswitch.wav",
    text: "ivr/ivr-welcome_to_freeswitch.wav",
  },
  {
    value: "ivr/ivr-were_asterisk_free.wav",
    text: "ivr/ivr-were_asterisk_free.wav",
  },
  {
    value: "ivr/ivr-when_finished_press_any_key.wav",
    text: "ivr/ivr-when_finished_press_any_key.wav",
  },
  { value: "ivr/ivr-withdrawn.wav", text: "ivr/ivr-withdrawn.wav" },
  {
    value: "ivr/ivr-would_you_like_to_receive_a_call_at_this_number.wav",
    text: "ivr/ivr-would_you_like_to_receive_a_call_at_this_number.wav",
  },
  {
    value: "ivr/ivr-yes_we_have_no_bananas.wav",
    text: "ivr/ivr-yes_we_have_no_bananas.wav",
  },
  {
    value: "ivr/ivr-you_are_about_to_provision_this_phone.wav",
    text: "ivr/ivr-you_are_about_to_provision_this_phone.wav",
  },
  {
    value: "ivr/ivr-you_are_now_logged_in.wav",
    text: "ivr/ivr-you_are_now_logged_in.wav",
  },
  {
    value: "ivr/ivr-you_are_now_logged_out.wav",
    text: "ivr/ivr-you_are_now_logged_out.wav",
  },
  { value: "ivr/ivr-you_are_number.wav", text: "ivr/ivr-you_are_number.wav" },
  {
    value: "ivr/ivr-you_are_number_one.wav",
    text: "ivr/ivr-you_are_number_one.wav",
  },
  { value: "ivr/ivr-you_are_the.wav", text: "ivr/ivr-you_are_the.wav" },
  { value: "ivr/ivr-you_entered.wav", text: "ivr/ivr-you_entered.wav" },
  {
    value: "ivr/ivr-you_have_dialed_an_invalid_extension.wav",
    text: "ivr/ivr-you_have_dialed_an_invalid_extension.wav",
  },
  { value: "ivr/ivr-you_have_used.wav", text: "ivr/ivr-you_have_used.wav" },
  { value: "ivr/ivr-you_lose.wav", text: "ivr/ivr-you_lose.wav" },
  { value: "ivr/ivr-you_may.wav", text: "ivr/ivr-you_may.wav" },
  {
    value: "ivr/ivr-you_may_exit_by_hanging_up.wav",
    text: "ivr/ivr-you_may_exit_by_hanging_up.wav",
  },
  {
    value: "ivr/ivr-your_caller_id_information_is.wav",
    text: "ivr/ivr-your_caller_id_information_is.wav",
  },
  {
    value: "ivr/ivr-your_caller_id_number_is_blocked.wav",
    text: "ivr/ivr-your_caller_id_number_is_blocked.wav",
  },
  {
    value: "ivr/ivr-youre_doing_it_wrong.wav",
    text: "ivr/ivr-youre_doing_it_wrong.wav",
  },
  {
    value: "ivr/ivr-yuno_silent_drill.wav",
    text: "ivr/ivr-yuno_silent_drill.wav",
  },
  {
    value: "ivr/ivr_connect_live_operator.wav",
    text: "ivr/ivr_connect_live_operator.wav",
  },
  {
    value: "misc/call_monitoring_blurb.wav",
    text: "misc/call_monitoring_blurb.wav",
  },
  { value: "misc/call_secured.wav", text: "misc/call_secured.wav" },
  { value: "misc/en.wav", text: "misc/en.wav" },
  { value: "misc/error.wav", text: "misc/error.wav" },
  { value: "misc/es.wav", text: "misc/es.wav" },
  { value: "misc/followed.wav", text: "misc/followed.wav" },
  {
    value: "misc/if_you_are_this_person.wav",
    text: "misc/if_you_are_this_person.wav",
  },
  {
    value: "misc/if_you_would_like_to.wav",
    text: "misc/if_you_would_like_to.wav",
  },
  { value: "misc/invalid_extension.wav", text: "misc/invalid_extension.wav" },
  { value: "misc/misc-Sangoma.wav", text: "misc/misc-Sangoma.wav" },
  {
    value: "misc/misc-chicago_each_summer.wav",
    text: "misc/misc-chicago_each_summer.wav",
  },
  {
    value: "misc/misc-cluecon_is_premier_conference.wav",
    text: "misc/misc-cluecon_is_premier_conference.wav",
  },
  {
    value: "misc/misc-cudatel_automagicatronical.wav",
    text: "misc/misc-cudatel_automagicatronical.wav",
  },
  { value: "misc/misc-cudatel_by_it.wav", text: "misc/misc-cudatel_by_it.wav" },
  {
    value: "misc/misc-cudatel_communication_server_from_barracuda.wav",
    text: "misc/misc-cudatel_communication_server_from_barracuda.wav",
  },
  {
    value: "misc/misc-cudatel_you_know_you_want_one.wav",
    text: "misc/misc-cudatel_you_know_you_want_one.wav",
  },
  {
    value: "misc/misc-free_to_download.wav",
    text: "misc/misc-free_to_download.wav",
  },
  {
    value: "misc/misc-freeswitch_dot_org_more.wav",
    text: "misc/misc-freeswitch_dot_org_more.wav",
  },
  {
    value: "misc/misc-freeswitch_is_state_of_the_art.wav",
    text: "misc/misc-freeswitch_is_state_of_the_art.wav",
  },
  {
    value: "misc/misc-freeswitch_sponsored_by_ostag.wav",
    text: "misc/misc-freeswitch_sponsored_by_ostag.wav",
  },
  {
    value: "misc/misc-fss_best_consulting.wav",
    text: "misc/misc-fss_best_consulting.wav",
  },
  {
    value: "misc/misc-fss_contact_us.wav",
    text: "misc/misc-fss_contact_us.wav",
  },
  {
    value: "misc/misc-fss_network_of_experts.wav",
    text: "misc/misc-fss_network_of_experts.wav",
  },
  {
    value: "misc/misc-information_about_freeswitch.wav",
    text: "misc/misc-information_about_freeswitch.wav",
  },
  {
    value: "misc/misc-it_is_stable_scalable_extensible.wav",
    text: "misc/misc-it_is_stable_scalable_extensible.wav",
  },
  {
    value: "misc/misc-join_us_each_wed.wav",
    text: "misc/misc-join_us_each_wed.wav",
  },
  {
    value: "misc/misc-koo_koo_for_cudatel.wav",
    text: "misc/misc-koo_koo_for_cudatel.wav",
  },
  {
    value: "misc/misc-learn_more_about_cudatel.wav",
    text: "misc/misc-learn_more_about_cudatel.wav",
  },
  {
    value: "misc/misc-learn_more_about_freeswitch_solutions.wav",
    text: "misc/misc-learn_more_about_freeswitch_solutions.wav",
  },
  {
    value: "misc/misc-more_info_wiki.wav",
    text: "misc/misc-more_info_wiki.wav",
  },
  {
    value: "misc/misc-ostag_learn_more.wav",
    text: "misc/misc-ostag_learn_more.wav",
  },
  { value: "misc/misc-soccer_mom.wav", text: "misc/misc-soccer_mom.wav" },
  {
    value: "misc/misc-speak_live_with_community.wav",
    text: "misc/misc-speak_live_with_community.wav",
  },
  {
    value: "misc/misc-speak_to_cudatel_rep.wav",
    text: "misc/misc-speak_to_cudatel_rep.wav",
  },
  {
    value: "misc/misc-support_open_source_by_attending.wav",
    text: "misc/misc-support_open_source_by_attending.wav",
  },
  {
    value: "misc/misc-to_hear_about_cluecon.wav",
    text: "misc/misc-to_hear_about_cluecon.wav",
  },
  {
    value: "misc/misc-visit_cudatel_dot_com.wav",
    text: "misc/misc-visit_cudatel_dot_com.wav",
  },
  {
    value: "misc/misc-welcome_freeswitch_conf_call.wav",
    text: "misc/misc-welcome_freeswitch_conf_call.wav",
  },
  {
    value: "misc/misc-wide_range_of_persons.wav",
    text: "misc/misc-wide_range_of_persons.wav",
  },
  {
    value: "misc/misc-your_call_has_been_terminated.wav",
    text: "misc/misc-your_call_has_been_terminated.wav",
  },
  {
    value: "misc/misc-your_call_will_be_terminated_in.wav",
    text: "misc/misc-your_call_will_be_terminated_in.wav",
  },
  { value: "misc/phone_not_auth.wav", text: "misc/phone_not_auth.wav" },
  {
    value: "misc/provide_reference_number.wav",
    text: "misc/provide_reference_number.wav",
  },
  { value: "misc/sorry.wav", text: "misc/sorry.wav" },
  { value: "misc/transfer1.wav", text: "misc/transfer1.wav" },
  { value: "misc/transfer2.wav", text: "misc/transfer2.wav" },
  {
    value: "misc/we_are_trying_to_reach.wav",
    text: "misc/we_are_trying_to_reach.wav",
  },
  { value: "phonetic-ascii/100.wav", text: "phonetic-ascii/100.wav" },
  { value: "phonetic-ascii/101.wav", text: "phonetic-ascii/101.wav" },
  { value: "phonetic-ascii/102.wav", text: "phonetic-ascii/102.wav" },
  { value: "phonetic-ascii/103.wav", text: "phonetic-ascii/103.wav" },
  { value: "phonetic-ascii/104.wav", text: "phonetic-ascii/104.wav" },
  { value: "phonetic-ascii/105.wav", text: "phonetic-ascii/105.wav" },
  { value: "phonetic-ascii/106.wav", text: "phonetic-ascii/106.wav" },
  { value: "phonetic-ascii/107.wav", text: "phonetic-ascii/107.wav" },
  { value: "phonetic-ascii/108.wav", text: "phonetic-ascii/108.wav" },
  { value: "phonetic-ascii/109.wav", text: "phonetic-ascii/109.wav" },
  { value: "phonetic-ascii/110.wav", text: "phonetic-ascii/110.wav" },
  { value: "phonetic-ascii/111.wav", text: "phonetic-ascii/111.wav" },
  { value: "phonetic-ascii/112.wav", text: "phonetic-ascii/112.wav" },
  { value: "phonetic-ascii/113.wav", text: "phonetic-ascii/113.wav" },
  { value: "phonetic-ascii/114.wav", text: "phonetic-ascii/114.wav" },
  { value: "phonetic-ascii/115.wav", text: "phonetic-ascii/115.wav" },
  { value: "phonetic-ascii/116.wav", text: "phonetic-ascii/116.wav" },
  { value: "phonetic-ascii/117.wav", text: "phonetic-ascii/117.wav" },
  { value: "phonetic-ascii/118.wav", text: "phonetic-ascii/118.wav" },
  { value: "phonetic-ascii/119.wav", text: "phonetic-ascii/119.wav" },
  { value: "phonetic-ascii/120.wav", text: "phonetic-ascii/120.wav" },
  { value: "phonetic-ascii/121.wav", text: "phonetic-ascii/121.wav" },
  { value: "phonetic-ascii/122.wav", text: "phonetic-ascii/122.wav" },
  { value: "phonetic-ascii/32.wav", text: "phonetic-ascii/32.wav" },
  { value: "phonetic-ascii/35.wav", text: "phonetic-ascii/35.wav" },
  { value: "phonetic-ascii/42.wav", text: "phonetic-ascii/42.wav" },
  { value: "phonetic-ascii/46.wav", text: "phonetic-ascii/46.wav" },
  { value: "phonetic-ascii/97.wav", text: "phonetic-ascii/97.wav" },
  { value: "phonetic-ascii/98.wav", text: "phonetic-ascii/98.wav" },
  { value: "phonetic-ascii/99.wav", text: "phonetic-ascii/99.wav" },
  { value: "time/a-m.wav", text: "time/a-m.wav" },
  { value: "time/at.wav", text: "time/at.wav" },
  { value: "time/day-0.wav", text: "time/day-0.wav" },
  { value: "time/day-1.wav", text: "time/day-1.wav" },
  { value: "time/day-2.wav", text: "time/day-2.wav" },
  { value: "time/day-3.wav", text: "time/day-3.wav" },
  { value: "time/day-4.wav", text: "time/day-4.wav" },
  { value: "time/day-5.wav", text: "time/day-5.wav" },
  { value: "time/day-6.wav", text: "time/day-6.wav" },
  { value: "time/hour.wav", text: "time/hour.wav" },
  { value: "time/hours.wav", text: "time/hours.wav" },
  { value: "time/minute.wav", text: "time/minute.wav" },
  { value: "time/minutes.wav", text: "time/minutes.wav" },
  { value: "time/mon-0.wav", text: "time/mon-0.wav" },
  { value: "time/mon-1.wav", text: "time/mon-1.wav" },
  { value: "time/mon-10.wav", text: "time/mon-10.wav" },
  { value: "time/mon-11.wav", text: "time/mon-11.wav" },
  { value: "time/mon-2.wav", text: "time/mon-2.wav" },
  { value: "time/mon-3.wav", text: "time/mon-3.wav" },
  { value: "time/mon-4.wav", text: "time/mon-4.wav" },
  { value: "time/mon-5.wav", text: "time/mon-5.wav" },
  { value: "time/mon-6.wav", text: "time/mon-6.wav" },
  { value: "time/mon-7.wav", text: "time/mon-7.wav" },
  { value: "time/mon-8.wav", text: "time/mon-8.wav" },
  { value: "time/mon-9.wav", text: "time/mon-9.wav" },
  { value: "time/oclock.wav", text: "time/oclock.wav" },
  { value: "time/oh.wav", text: "time/oh.wav" },
  { value: "time/p-m.wav", text: "time/p-m.wav" },
  { value: "time/second.wav", text: "time/second.wav" },
  { value: "time/seconds.wav", text: "time/seconds.wav" },
  { value: "time/today.wav", text: "time/today.wav" },
  { value: "time/tomorrow.wav", text: "time/tomorrow.wav" },
  { value: "time/yesterday.wav", text: "time/yesterday.wav" },
  { value: "voicemail/vm-abort.wav", text: "voicemail/vm-abort.wav" },
  { value: "voicemail/vm-advanced.wav", text: "voicemail/vm-advanced.wav" },
  {
    value: "voicemail/vm-advanced_alt.wav",
    text: "voicemail/vm-advanced_alt.wav",
  },
  {
    value: "voicemail/vm-change_password.wav",
    text: "voicemail/vm-change_password.wav",
  },
  {
    value: "voicemail/vm-choose_greeting.wav",
    text: "voicemail/vm-choose_greeting.wav",
  },
  {
    value: "voicemail/vm-choose_greeting_choose.wav",
    text: "voicemail/vm-choose_greeting_choose.wav",
  },
  {
    value: "voicemail/vm-choose_greeting_fail.wav",
    text: "voicemail/vm-choose_greeting_fail.wav",
  },
  {
    value: "voicemail/vm-choose_password.wav",
    text: "voicemail/vm-choose_password.wav",
  },
  { value: "voicemail/vm-continue.wav", text: "voicemail/vm-continue.wav" },
  {
    value: "voicemail/vm-delete_message.wav",
    text: "voicemail/vm-delete_message.wav",
  },
  {
    value: "voicemail/vm-delete_recording.wav",
    text: "voicemail/vm-delete_recording.wav",
  },
  { value: "voicemail/vm-deleted.wav", text: "voicemail/vm-deleted.wav" },
  { value: "voicemail/vm-emailed.wav", text: "voicemail/vm-emailed.wav" },
  { value: "voicemail/vm-enter_id.wav", text: "voicemail/vm-enter_id.wav" },
  {
    value: "voicemail/vm-enter_new_pin.wav",
    text: "voicemail/vm-enter_new_pin.wav",
  },
  { value: "voicemail/vm-enter_pass.wav", text: "voicemail/vm-enter_pass.wav" },
  { value: "voicemail/vm-fail_auth.wav", text: "voicemail/vm-fail_auth.wav" },
  {
    value: "voicemail/vm-followed_by.wav",
    text: "voicemail/vm-followed_by.wav",
  },
  {
    value: "voicemail/vm-followed_by_pound.wav",
    text: "voicemail/vm-followed_by_pound.wav",
  },
  {
    value: "voicemail/vm-forward_add_intro.wav",
    text: "voicemail/vm-forward_add_intro.wav",
  },
  {
    value: "voicemail/vm-forward_enter_ext.wav",
    text: "voicemail/vm-forward_enter_ext.wav",
  },
  {
    value: "voicemail/vm-forward_to_email.wav",
    text: "voicemail/vm-forward_to_email.wav",
  },
  { value: "voicemail/vm-from.wav", text: "voicemail/vm-from.wav" },
  { value: "voicemail/vm-goodbye.wav", text: "voicemail/vm-goodbye.wav" },
  { value: "voicemail/vm-greeting.wav", text: "voicemail/vm-greeting.wav" },
  {
    value: "voicemail/vm-has_been_changed_to.wav",
    text: "voicemail/vm-has_been_changed_to.wav",
  },
  { value: "voicemail/vm-hello.wav", text: "voicemail/vm-hello.wav" },
  { value: "voicemail/vm-in_folder.wav", text: "voicemail/vm-in_folder.wav" },
  { value: "voicemail/vm-last.wav", text: "voicemail/vm-last.wav" },
  { value: "voicemail/vm-listen_new.wav", text: "voicemail/vm-listen_new.wav" },
  {
    value: "voicemail/vm-listen_saved.wav",
    text: "voicemail/vm-listen_saved.wav",
  },
  {
    value: "voicemail/vm-listen_to_recording.wav",
    text: "voicemail/vm-listen_to_recording.wav",
  },
  {
    value: "voicemail/vm-listen_to_recording_again.wav",
    text: "voicemail/vm-listen_to_recording_again.wav",
  },
  {
    value: "voicemail/vm-mailbox_full.wav",
    text: "voicemail/vm-mailbox_full.wav",
  },
  { value: "voicemail/vm-main_menu.wav", text: "voicemail/vm-main_menu.wav" },
  {
    value: "voicemail/vm-main_menu_alt.wav",
    text: "voicemail/vm-main_menu_alt.wav",
  },
  {
    value: "voicemail/vm-mark-urgent.wav",
    text: "voicemail/vm-mark-urgent.wav",
  },
  {
    value: "voicemail/vm-mark_message_new.wav",
    text: "voicemail/vm-mark_message_new.wav",
  },
  {
    value: "voicemail/vm-marked-urgent.wav",
    text: "voicemail/vm-marked-urgent.wav",
  },
  { value: "voicemail/vm-marked_new.wav", text: "voicemail/vm-marked_new.wav" },
  { value: "voicemail/vm-message.wav", text: "voicemail/vm-message.wav" },
  {
    value: "voicemail/vm-message_alt.wav",
    text: "voicemail/vm-message_alt.wav",
  },
  {
    value: "voicemail/vm-message_envelope.wav",
    text: "voicemail/vm-message_envelope.wav",
  },
  {
    value: "voicemail/vm-message_forwarded.wav",
    text: "voicemail/vm-message_forwarded.wav",
  },
  {
    value: "voicemail/vm-message_from.wav",
    text: "voicemail/vm-message_from.wav",
  },
  {
    value: "voicemail/vm-message_number.wav",
    text: "voicemail/vm-message_number.wav",
  },
  { value: "voicemail/vm-messages.wav", text: "voicemail/vm-messages.wav" },
  {
    value: "voicemail/vm-messages_alt.wav",
    text: "voicemail/vm-messages_alt.wav",
  },
  {
    value: "voicemail/vm-minimum_pin_length_is.wav",
    text: "voicemail/vm-minimum_pin_length_is.wav",
  },
  { value: "voicemail/vm-new.wav", text: "voicemail/vm-new.wav" },
  { value: "voicemail/vm-next.wav", text: "voicemail/vm-next.wav" },
  {
    value: "voicemail/vm-no_answer_no_vm.wav",
    text: "voicemail/vm-no_answer_no_vm.wav",
  },
  {
    value: "voicemail/vm-no_more_messages.wav",
    text: "voicemail/vm-no_more_messages.wav",
  },
  {
    value: "voicemail/vm-nobody_leaving_message.wav",
    text: "voicemail/vm-nobody_leaving_message.wav",
  },
  {
    value: "voicemail/vm-not_available.wav",
    text: "voicemail/vm-not_available.wav",
  },
  {
    value: "voicemail/vm-not_available_no_voicemail.wav",
    text: "voicemail/vm-not_available_no_voicemail.wav",
  },
  {
    value: "voicemail/vm-password_has_been_changed.wav",
    text: "voicemail/vm-password_has_been_changed.wav",
  },
  {
    value: "voicemail/vm-password_is_not_secure.wav",
    text: "voicemail/vm-password_is_not_secure.wav",
  },
  {
    value: "voicemail/vm-password_not_valid.wav",
    text: "voicemail/vm-password_not_valid.wav",
  },
  { value: "voicemail/vm-person.wav", text: "voicemail/vm-person.wav" },
  {
    value: "voicemail/vm-pin_below_minimum_length.wav",
    text: "voicemail/vm-pin_below_minimum_length.wav",
  },
  {
    value: "voicemail/vm-play_greeting.wav",
    text: "voicemail/vm-play_greeting.wav",
  },
  {
    value: "voicemail/vm-play_next_message.wav",
    text: "voicemail/vm-play_next_message.wav",
  },
  {
    value: "voicemail/vm-play_previous_message.wav",
    text: "voicemail/vm-play_previous_message.wav",
  },
  { value: "voicemail/vm-press.wav", text: "voicemail/vm-press.wav" },
  { value: "voicemail/vm-received.wav", text: "voicemail/vm-received.wav" },
  {
    value: "voicemail/vm-record_greeting.wav",
    text: "voicemail/vm-record_greeting.wav",
  },
  {
    value: "voicemail/vm-record_message.wav",
    text: "voicemail/vm-record_message.wav",
  },
  {
    value: "voicemail/vm-record_name1.wav",
    text: "voicemail/vm-record_name1.wav",
  },
  {
    value: "voicemail/vm-record_name2.wav",
    text: "voicemail/vm-record_name2.wav",
  },
  {
    value: "voicemail/vm-repeat_message.wav",
    text: "voicemail/vm-repeat_message.wav",
  },
  { value: "voicemail/vm-rerecord.wav", text: "voicemail/vm-rerecord.wav" },
  {
    value: "voicemail/vm-return_call.wav",
    text: "voicemail/vm-return_call.wav",
  },
  {
    value: "voicemail/vm-save_message.wav",
    text: "voicemail/vm-save_message.wav",
  },
  {
    value: "voicemail/vm-save_recording.wav",
    text: "voicemail/vm-save_recording.wav",
  },
  { value: "voicemail/vm-saved.wav", text: "voicemail/vm-saved.wav" },
  { value: "voicemail/vm-selected.wav", text: "voicemail/vm-selected.wav" },
  {
    value: "voicemail/vm-send_message_now.wav",
    text: "voicemail/vm-send_message_now.wav",
  },
  {
    value: "voicemail/vm-that_was_an_invalid_ext.wav",
    text: "voicemail/vm-that_was_an_invalid_ext.wav",
  },
  { value: "voicemail/vm-to_exit.wav", text: "voicemail/vm-to_exit.wav" },
  {
    value: "voicemail/vm-to_exit_alt.wav",
    text: "voicemail/vm-to_exit_alt.wav",
  },
  { value: "voicemail/vm-to_forward.wav", text: "voicemail/vm-to_forward.wav" },
  {
    value: "voicemail/vm-to_record_greeting.wav",
    text: "voicemail/vm-to_record_greeting.wav",
  },
  { value: "voicemail/vm-too-small.wav", text: "voicemail/vm-too-small.wav" },
  {
    value: "voicemail/vm-tutorial_change_pin.wav",
    text: "voicemail/vm-tutorial_change_pin.wav",
  },
  {
    value: "voicemail/vm-tutorial_record_name.wav",
    text: "voicemail/vm-tutorial_record_name.wav",
  },
  {
    value: "voicemail/vm-tutorial_yes_no.wav",
    text: "voicemail/vm-tutorial_yes_no.wav",
  },
  {
    value: "voicemail/vm-undelete_message.wav",
    text: "voicemail/vm-undelete_message.wav",
  },
  { value: "voicemail/vm-undeleted.wav", text: "voicemail/vm-undeleted.wav" },
  { value: "voicemail/vm-urgent-new.wav", text: "voicemail/vm-urgent-new.wav" },
  {
    value: "voicemail/vm-urgent-saved.wav",
    text: "voicemail/vm-urgent-saved.wav",
  },
  { value: "voicemail/vm-urgent.wav", text: "voicemail/vm-urgent.wav" },
  {
    value: "voicemail/vm-voicemail_password_is_web_password.wav",
    text: "voicemail/vm-voicemail_password_is_web_password.wav",
  },
  { value: "voicemail/vm-you_have.wav", text: "voicemail/vm-you_have.wav" },
  { value: "zrtp/zrtp-check_sas.wav", text: "zrtp/zrtp-check_sas.wav" },
  {
    value: "zrtp/zrtp-enroll_already_enrolled.wav",
    text: "zrtp/zrtp-enroll_already_enrolled.wav",
  },
  {
    value: "zrtp/zrtp-enroll_confirmed.wav",
    text: "zrtp/zrtp-enroll_confirmed.wav",
  },
  {
    value: "zrtp/zrtp-enroll_not_sip_registered.wav",
    text: "zrtp/zrtp-enroll_not_sip_registered.wav",
  },
  {
    value: "zrtp/zrtp-enroll_notzrtp.wav",
    text: "zrtp/zrtp-enroll_notzrtp.wav",
  },
  {
    value: "zrtp/zrtp-enroll_welcome.wav",
    text: "zrtp/zrtp-enroll_welcome.wav",
  },
  { value: "zrtp/zrtp-is_secure.wav", text: "zrtp/zrtp-is_secure.wav" },
  { value: "zrtp/zrtp-is_unverified.wav", text: "zrtp/zrtp-is_unverified.wav" },
  { value: "zrtp/zrtp-is_verified.wav", text: "zrtp/zrtp-is_verified.wav" },
  {
    value: "zrtp/zrtp-somethings_wrong.wav",
    text: "zrtp/zrtp-somethings_wrong.wav",
  },
  { value: "zrtp/zrtp-status_error.wav", text: "zrtp/zrtp-status_error.wav" },
  {
    value: "zrtp/zrtp-status_notsecure.wav",
    text: "zrtp/zrtp-status_notsecure.wav",
  },
  { value: "zrtp/zrtp-status_secure.wav", text: "zrtp/zrtp-status_secure.wav" },
  {
    value: "zrtp/zrtp-status_securing.wav",
    text: "zrtp/zrtp-status_securing.wav",
  },
  {
    value: "zrtp/zrtp-thankyou_goodbye.wav",
    text: "zrtp/zrtp-thankyou_goodbye.wav",
  },
];

export const langOptions = [
  { value: "en", label: "English (US)" },
  { value: "zh", label: "Chinese" },
  { value: "fr", label: "French" },
  { value: "ja", label: "Japanese" },
  { value: "es", label: "Spanish" },
];

export const timeZoneOptions = [
  { value: "America/New_York", text: "America/New_York" },
  { value: "America/Chicago", text: "America/Chicago" },
  { value: "America/Adak", text: "America/Adak" },
  { value: "America/Anchorage", text: "America/Anchorage" },
  { value: "America/Anguilla", text: "America/Anguilla" },
  { value: "America/Antigua", text: "America/Antigua" },
  { value: "America/Araguaina", text: "America/Araguaina" },
  {
    value: "America/Argentina/Buenos_Aires",
    text: "America/Argentina/Buenos_Aires",
  },
  { value: "America/Argentina/Catamarca", text: "America/Argentina/Catamarca" },
  {
    value: "America/Argentina/ComodRivadavia",
    text: "America/Argentina/ComodRivadavia",
  },
  { value: "America/Argentina/Cordoba", text: "America/Argentina/Cordoba" },
  { value: "America/Argentina/Jujuy", text: "America/Argentina/Jujuy" },
  { value: "America/Argentina/La_Rioja", text: "America/Argentina/La_Rioja" },
  { value: "America/Argentina/Mendoza", text: "America/Argentina/Mendoza" },
  {
    value: "America/Argentina/Rio_Gallegos",
    text: "America/Argentina/Rio_Gallegos",
  },
  { value: "America/Argentina/Salta", text: "America/Argentina/Salta" },
  { value: "America/Argentina/San_Juan", text: "America/Argentina/San_Juan" },
  { value: "America/Argentina/San_Luis", text: "America/Argentina/San_Luis" },
  { value: "America/Argentina/Tucuman", text: "America/Argentina/Tucuman" },
  { value: "America/Argentina/Ushuaia", text: "America/Argentina/Ushuaia" },
  { value: "America/Aruba", text: "America/Aruba" },
  { value: "America/Asuncion", text: "America/Asuncion" },
  { value: "America/Atikokan", text: "America/Atikokan" },
  { value: "America/Atka", text: "America/Atka" },
  { value: "America/Bahia", text: "America/Bahia" },
  { value: "America/Bahia_Banderas", text: "America/Bahia_Banderas" },
  { value: "America/Barbados", text: "America/Barbados" },
  { value: "America/Belem", text: "America/Belem" },
  { value: "America/Belize", text: "America/Belize" },
  { value: "America/Blanc-Sablon", text: "America/Blanc-Sablon" },
  { value: "America/Boa_Vista", text: "America/Boa_Vista" },
  { value: "America/Bogota", text: "America/Bogota" },
  { value: "America/Boise", text: "America/Boise" },
  { value: "America/Buenos_Aires", text: "America/Buenos_Aires" },
  { value: "America/Cambridge_Bay", text: "America/Cambridge_Bay" },
  { value: "America/Campo_Grande", text: "America/Campo_Grande" },
  { value: "America/Cancun", text: "America/Cancun" },
  { value: "America/Caracas", text: "America/Caracas" },
  { value: "America/Catamarca", text: "America/Catamarca" },
  { value: "America/Cayenne", text: "America/Cayenne" },
  { value: "America/Cayman", text: "America/Cayman" },
  { value: "America/Chihuahua", text: "America/Chihuahua" },
  { value: "America/Coral_Harbour", text: "America/Coral_Harbour" },
  { value: "America/Cordoba", text: "America/Cordoba" },
  { value: "America/Costa_Rica", text: "America/Costa_Rica" },
  { value: "America/Creston", text: "America/Creston" },
  { value: "America/Cuiaba", text: "America/Cuiaba" },
  { value: "America/Curacao", text: "America/Curacao" },
  { value: "America/Danmarkshavn", text: "America/Danmarkshavn" },
  { value: "America/Dawson", text: "America/Dawson" },
  { value: "America/Dawson_Creek", text: "America/Dawson_Creek" },
  { value: "America/Denver", text: "America/Denver" },
  { value: "America/Detroit", text: "America/Detroit" },
  { value: "America/Dominica", text: "America/Dominica" },
  { value: "America/Edmonton", text: "America/Edmonton" },
  { value: "America/Eirunepe", text: "America/Eirunepe" },
  { value: "America/El_Salvador", text: "America/El_Salvador" },
  { value: "America/Ensenada", text: "America/Ensenada" },
  { value: "America/Fort_Nelson", text: "America/Fort_Nelson" },
  { value: "America/Fort_Wayne", text: "America/Fort_Wayne" },
  { value: "America/Fortaleza", text: "America/Fortaleza" },
  { value: "America/Glace_Bay", text: "America/Glace_Bay" },
  { value: "America/Godthab", text: "America/Godthab" },
  { value: "America/Goose_Bay", text: "America/Goose_Bay" },
  { value: "America/Grand_Turk", text: "America/Grand_Turk" },
  { value: "America/Grenada", text: "America/Grenada" },
  { value: "America/Guadeloupe", text: "America/Guadeloupe" },
  { value: "America/Guatemala", text: "America/Guatemala" },
  { value: "America/Guayaquil", text: "America/Guayaquil" },
  { value: "America/Guyana", text: "America/Guyana" },
  { value: "America/Halifax", text: "America/Halifax" },
  { value: "America/Havana", text: "America/Havana" },
  { value: "America/Hermosillo", text: "America/Hermosillo" },
  {
    value: "America/Indiana/Indianapolis",
    text: "America/Indiana/Indianapolis",
  },
  { value: "America/Indiana/Knox", text: "America/Indiana/Knox" },
  { value: "America/Indiana/Marengo", text: "America/Indiana/Marengo" },
  { value: "America/Indiana/Petersburg", text: "America/Indiana/Petersburg" },
  { value: "America/Indiana/Tell_City", text: "America/Indiana/Tell_City" },
  { value: "America/Indiana/Vevay", text: "America/Indiana/Vevay" },
  { value: "America/Indiana/Vincennes", text: "America/Indiana/Vincennes" },
  { value: "America/Indiana/Winamac", text: "America/Indiana/Winamac" },
  { value: "America/Indianapolis", text: "America/Indianapolis" },
  { value: "America/Inuvik", text: "America/Inuvik" },
  { value: "America/Iqaluit", text: "America/Iqaluit" },
  { value: "America/Jamaica", text: "America/Jamaica" },
  { value: "America/Jujuy", text: "America/Jujuy" },
  { value: "America/Juneau", text: "America/Juneau" },
  { value: "America/Kentucky/Louisville", text: "America/Kentucky/Louisville" },
  { value: "America/Kentucky/Monticello", text: "America/Kentucky/Monticello" },
  { value: "America/Knox_IN", text: "America/Knox_IN" },
  { value: "America/Kralendijk", text: "America/Kralendijk" },
  { value: "America/La_Paz", text: "America/La_Paz" },
  { value: "America/Lima", text: "America/Lima" },
  { value: "America/Los_Angeles", text: "America/Los_Angeles" },
  { value: "America/Louisville", text: "America/Louisville" },
  { value: "America/Lower_Princes", text: "America/Lower_Princes" },
  { value: "America/Maceio", text: "America/Maceio" },
  { value: "America/Managua", text: "America/Managua" },
  { value: "America/Manaus", text: "America/Manaus" },
  { value: "America/Marigot", text: "America/Marigot" },
  { value: "America/Martinique", text: "America/Martinique" },
  { value: "America/Matamoros", text: "America/Matamoros" },
  { value: "America/Mazatlan", text: "America/Mazatlan" },
  { value: "America/Mendoza", text: "America/Mendoza" },
  { value: "America/Menominee", text: "America/Menominee" },
  { value: "America/Merida", text: "America/Merida" },
  { value: "America/Metlakatla", text: "America/Metlakatla" },
  { value: "America/Mexico_City", text: "America/Mexico_City" },
  { value: "America/Miquelon", text: "America/Miquelon" },
  { value: "America/Moncton", text: "America/Moncton" },
  { value: "America/Monterrey", text: "America/Monterrey" },
  { value: "America/Montevideo", text: "America/Montevideo" },
  { value: "America/Montreal", text: "America/Montreal" },
  { value: "America/Montserrat", text: "America/Montserrat" },
  { value: "America/Nassau", text: "America/Nassau" },
  { value: "America/Nipigon", text: "America/Nipigon" },
  { value: "America/Nome", text: "America/Nome" },
  { value: "America/Noronha", text: "America/Noronha" },
  { value: "America/North_Dakota/Beulah", text: "America/North_Dakota/Beulah" },
  { value: "America/North_Dakota/Center", text: "America/North_Dakota/Center" },
  {
    value: "America/North_Dakota/New_Salem",
    text: "America/North_Dakota/New_Salem",
  },
  { value: "America/Ojinaga", text: "America/Ojinaga" },
  { value: "America/Panama", text: "America/Panama" },
  { value: "America/Pangnirtung", text: "America/Pangnirtung" },
  { value: "America/Paramaribo", text: "America/Paramaribo" },
  { value: "America/Phoenix", text: "America/Phoenix" },
  { value: "America/Port-au-Prince", text: "America/Port-au-Prince" },
  { value: "America/Port_of_Spain", text: "America/Port_of_Spain" },
  { value: "America/Porto_Acre", text: "America/Porto_Acre" },
  { value: "America/Porto_Velho", text: "America/Porto_Velho" },
  { value: "America/Puerto_Rico", text: "America/Puerto_Rico" },
  { value: "America/Punta_Arenas", text: "America/Punta_Arenas" },
  { value: "America/Rainy_River", text: "America/Rainy_River" },
  { value: "America/Rankin_Inlet", text: "America/Rankin_Inlet" },
  { value: "America/Recife", text: "America/Recife" },
  { value: "America/Regina", text: "America/Regina" },
  { value: "America/Resolute", text: "America/Resolute" },
  { value: "America/Rio_Branco", text: "America/Rio_Branco" },
  { value: "America/Rosario", text: "America/Rosario" },
  { value: "America/Santa_Isabel", text: "America/Santa_Isabel" },
  { value: "America/Santarem", text: "America/Santarem" },
  { value: "America/Santiago", text: "America/Santiago" },
  { value: "America/Santo_Domingo", text: "America/Santo_Domingo" },
  { value: "America/Sao_Paulo", text: "America/Sao_Paulo" },
  { value: "America/Scoresbysund", text: "America/Scoresbysund" },
  { value: "America/Shiprock", text: "America/Shiprock" },
  { value: "America/Sitka", text: "America/Sitka" },
  { value: "America/St_Barthelemy", text: "America/St_Barthelemy" },
  { value: "America/St_Johns", text: "America/St_Johns" },
  { value: "America/St_Kitts", text: "America/St_Kitts" },
  { value: "America/St_Lucia", text: "America/St_Lucia" },
  { value: "America/St_Thomas", text: "America/St_Thomas" },
  { value: "America/St_Vincent", text: "America/St_Vincent" },
  { value: "America/Swift_Current", text: "America/Swift_Current" },
  { value: "America/Tegucigalpa", text: "America/Tegucigalpa" },
  { value: "America/Thule", text: "America/Thule" },
  { value: "America/Thunder_Bay", text: "America/Thunder_Bay" },
  { value: "America/Tijuana", text: "America/Tijuana" },
  { value: "America/Toronto", text: "America/Toronto" },
  { value: "America/Tortola", text: "America/Tortola" },
  { value: "America/Vancouver", text: "America/Vancouver" },
  { value: "America/Virgin", text: "America/Virgin" },
  { value: "America/Whitehorse", text: "America/Whitehorse" },
  { value: "America/Winnipeg", text: "America/Winnipeg" },
  { value: "America/Yakutat", text: "America/Yakutat" },
  { value: "America/Yellowknife", text: "America/Yellowknife" },
  { value: "Asia/Aden", text: "Asia/Aden" },
  { value: "US/Alaska", text: "US/Alaska" },
  { value: "US/Aleutian", text: "US/Aleutian" },
  { value: "US/Arizona", text: "US/Arizona" },
  { value: "US/Central", text: "US/Central" },
  { value: "US/East-Indiana", text: "US/East-Indiana" },
  { value: "US/Eastern", text: "US/Eastern" },
  { value: "US/Hawaii", text: "US/Hawaii" },
  { value: "US/Indiana-Starke", text: "US/Indiana-Starke" },
  { value: "US/Michigan", text: "US/Michigan" },
  { value: "US/Mountain", text: "US/Mountain" },
  { value: "US/Pacific", text: "US/Pacific" },
  { value: "US/Pacific-New", text: "US/Pacific-New" },
  { value: "US/Samoa", text: "US/Samoa" },
];

export const pmsType = [
  { label: "Select PMS Type", value: "" },
  { label: "Anand system Inetreface", value: "asi" },
  { label: "Mitel", value: "mitel" },
  { label: "Hotel Key", value: "hotel_key" },
  { label: "FIAS", value: "fias" },
  { label: "WebRez", value: "webRez" },
  { label: "CHAR", value: "char" },
  { label: "Stay N Touch", value: "stayntouch" },
];

export const permissionMenuOptionOp = [
  {
    name: "Super Dashboard",
    isSuperAdmin: true,
    selectedPermission: ["is_view", "is_edit", "is_delete"],
  },
  {
    name: "Domain",
    isSuperAdmin: true,
    selectedPermission: ["is_view", "is_edit", "is_delete"],
  },
  {
    name: "Device Data",
    isSuperAdmin: true,
    selectedPermission: ["is_view", "is_edit", "is_delete"],
  },
  {
    name: "User Permission",
    isSuperAdmin: true,
    menuName: "Users",
    selectedPermission: ["is_view", "is_edit", "is_delete"],
  },
  {
    name: "Staff Users",
    isSuperAdmin: true,
    menuName: "Users",
    selectedPermission: ["is_view", "is_edit", "is_delete"],
  },
  {
    name: "Reseller User",
    isSuperAdmin: true,
    menuName: "Users",
    selectedPermission: ["is_view", "is_edit", "is_delete"],
  },
  {
    name: "Property Users",
    isSuperAdmin: true,
    menuName: "Users",
    selectedPermission: ["is_view", "is_edit", "is_delete"],
  },
  {
    name: "Phone Numbers",
    isSuperAdmin: true,
    menuName: "Phone Number",
    selectedPermission: ["is_view", "is_edit", "is_delete"],
  },
  {
    name: "Destinations",
    isSuperAdmin: true,
    menuName: "Phone Number",
    selectedPermission: ["is_view", "is_edit", "is_delete"],
  },
  {
    name: "Porting",
    isSuperAdmin: true,
    menuName: "Phone Number",
    selectedPermission: ["is_view", "is_edit", "is_delete"],
  },
  {
    name: "Servers",
    isSuperAdmin: true,
    menuName: "Setting",
    selectedPermission: ["is_view", "is_edit", "is_delete"],
  },
  {
    name: "Security Group",
    isSuperAdmin: true,
    menuName: "Setting",
    selectedPermission: ["is_view", "is_edit", "is_delete"],
  },
  {
    name: "Device Profile",
    isSuperAdmin: true,
    menuName: "Setting",
    selectedPermission: ["is_view", "is_edit", "is_delete"],
  },
  {
    name: "Service Provider",
    isSuperAdmin: true,
    menuName: "Setting",
    selectedPermission: ["is_view", "is_edit", "is_delete"],
  },
  {
    name: "Server Health",
    isSuperAdmin: true,
    menuName: "Setting",
    selectedPermission: ["is_view", "is_edit", "is_delete"],
  },
  {
    name: "Media Server",
    isSuperAdmin: true,
    menuName: "Server",
    selectedPermission: ["is_view", "is_edit", "is_delete"],
  },
  {
    name: "Ip Server",
    isSuperAdmin: true,
    menuName: "Server",
    selectedPermission: ["is_view", "is_edit", "is_delete"],
  },
  {
    name: "Blocked Ip",
    isSuperAdmin: true,
    menuName: "Server",
    selectedPermission: ["is_view", "is_edit", "is_delete"],
  },
  {
    name: "IP Whitelist",
    isSuperAdmin: true,
    menuName: "Server",
    selectedPermission: ["is_view", "is_edit", "is_delete"],
  },

  {
    name: "Dashboard",
    isSuperAdmin: false,
    selectedPermission: ["is_view", "is_edit", "is_delete"],
  },
  {
    name: "Edit Account",
    isSuperAdmin: false,
    selectedPermission: ["is_view", "is_edit", "is_delete"],
  },
  {
    name: "Edit Domain",
    isSuperAdmin: false,
    selectedPermission: ["is_view", "is_edit", "is_delete"],
  },
  {
    name: "Edit Domain Notes",
    isSuperAdmin: false,
    selectedPermission: ["is_view", "is_edit", "is_delete"],
  },
  {
    name: "Devices",
    isSuperAdmin: false,
    selectedPermission: ["is_view", "is_edit", "is_delete"],
  },
  {
    name: "Extensions",
    isSuperAdmin: false,
    selectedPermission: ["is_view", "is_edit", "is_delete"],
  },
  {
    name: "Registrations",
    isSuperAdmin: false,
    selectedPermission: ["is_view", "is_edit", "is_delete"],
  },
  {
    name: "Voice Mail",
    isSuperAdmin: false,
    selectedPermission: ["is_view", "is_edit", "is_delete"],
  },
  {
    name: "Phone Number",
    isSuperAdmin: false,
    selectedPermission: ["is_view", "is_edit", "is_delete"],
  },
  {
    name: "Ring Group",
    isSuperAdmin: false,
    menuName: "App",
    selectedPermission: ["is_view", "is_edit", "is_delete"],
  },
  {
    name: "Voice Menu",
    isSuperAdmin: false,
    menuName: "App",
    selectedPermission: ["is_view", "is_edit", "is_delete"],
  },
  {
    name: "Call Flow",
    isSuperAdmin: false,
    menuName: "App",
    selectedPermission: ["is_view", "is_edit", "is_delete"],
  },
  {
    name: "Media",
    isSuperAdmin: false,
    menuName: "App",
    selectedPermission: ["is_view", "is_edit", "is_delete"],
  },
  {
    name: "Call Records",
    isSuperAdmin: false,
    selectedPermission: ["is_view", "is_edit", "is_delete"],
  },
  {
    name: "Campaign Template List",
    isSuperAdmin: false,
    menuName: "Campaign",
    selectedPermission: ["is_view", "is_edit", "is_delete"],
  },
  {
    name: "Campaign",
    isSuperAdmin: false,
    menuName: "Campaign",
    selectedPermission: ["is_view", "is_edit", "is_delete"],
  },
  {
    name: "Logs",
    isSuperAdmin: false,
    menuName: "Campaign",
    selectedPermission: ["is_view", "is_edit", "is_delete"],
  },
  {
    name: "List",
    isSuperAdmin: false,
    menuName: "Campaign",
    selectedPermission: ["is_view", "is_edit", "is_delete"],
  },
  {
    name: "Fax",
    isSuperAdmin: false,
    selectedPermission: ["is_view", "is_edit", "is_delete"],
  },
  {
    name: "Wakeup Call",
    isSuperAdmin: false,
    selectedPermission: ["is_view", "is_edit", "is_delete"],
  },
  {
    name: "Subscription",
    isSuperAdmin: false,
    menuName: "My Account",
    selectedPermission: ["is_view", "is_edit", "is_delete"],
  },
  {
    name: "Invoices",
    isSuperAdmin: false,
    menuName: "My Account",
    selectedPermission: ["is_view", "is_edit", "is_delete"],
  },
  {
    name: "Ticket",
    isSuperAdmin: false,
    menuName: "My Account",
    selectedPermission: ["is_view", "is_edit", "is_delete"],
  },
  {
    name: "Room Status",
    isSuperAdmin: false,
    menuName: "Hotel App",
    selectedPermission: ["is_view", "is_edit", "is_delete"],
  },
  {
    name: "Call Rates",
    isSuperAdmin: false,
    menuName: "Hotel App",
    selectedPermission: ["is_view", "is_edit", "is_delete"],
  },
  {
    name: "Extension User",
    isSuperAdmin: true,
    selectedPermission: ["is_view", "is_edit", "is_delete"],
  },
  {
    name: "PPP User",
    isSuperAdmin: true,
    menuName: "Network",
    selectedPermission: ["is_view", "is_edit", "is_delete"],
  },
  {
    name: "Mobile App Provision",
    isSuperAdmin: true,
    selectedPermission: ["is_view", "is_edit", "is_delete"],
  },
  {
    name: "Map",
    isSuperAdmin: true,
    selectedPermission: ["is_view", "is_edit", "is_delete"],
  },
  {
    name: "Mobile App User",
    isSuperAdmin: true,
    selectedPermission: ["is_view", "is_edit", "is_delete"],
  },
  {
    name: "Contact Book List",
    isSuperAdmin: false,
    selectedPermission: ["is_view", "is_edit", "is_delete"],
  },
  {
    name: "ID Scan App",
    isSuperAdmin: true,
    selectedPermission: ["is_view", "is_edit", "is_delete"],
  },
  {
    name: "Alerts",
    isSuperAdmin: true,
    selectedPermission: ["is_view", "is_edit", "is_delete"],
  },
  {
    name: "Time Condition",
    isSuperAdmin: false,
    selectedPermission: ["is_view", "is_edit", "is_delete"],
  },
  {
    name: "Call Center",
    isSuperAdmin: false,
    selectedPermission: ["is_view", "is_edit", "is_delete"],
  },
  {
    name: "CC-Agents",
    isSuperAdmin: false,
    selectedPermission: ["is_view", "is_edit", "is_delete"],
  },
  {
    name: "CC-Queues",
    isSuperAdmin: false,
    selectedPermission: ["is_view", "is_edit", "is_delete"],
  },
  {
    name: "CC-Reports",
    isSuperAdmin: false,
    selectedPermission: ["is_view", "is_edit", "is_delete"],
  },
  {
    name: "CC-Dashboard",
    isSuperAdmin: false,
    selectedPermission: ["is_view", "is_edit", "is_delete"],
  },
  {
    name: "Staff",
    isSuperAdmin: false,
    selectedPermission: ["is_view", "is_edit", "is_delete"],
  },
  {
    name: "Messaging",
    isSuperAdmin: false,
    selectedPermission: ["is_view", "is_edit", "is_delete"],
  },
];

export const deviceLineKeyOptions = [
  { value: "", label: "" },
  { value: "0", label: "N/A" },
  { value: "15", label: "Line" },
  { value: "13", label: "Speed Dial" },
  { value: "16", label: "BLF" },
  { value: "39", label: "BLF List" },
  { value: "12", label: "Voicemail" },
  { value: "9", label: "Call Pickup" },
  { value: "23", label: "Group Pickup" },
  { value: "10", label: "Call Park" },
  { value: "14", label: "Intercom" },
  { value: "11", label: "DTMF" },
  { value: "40", label: "Prefix" },
  { value: "45", label: "Local Group" },
  { value: "22", label: "XML Group" },
  { value: "27", label: "XML Browser" },
  { value: "1", label: "Conference" },
  { value: "2", label: "Forward" },
  { value: "3", label: "Transfer" },
  { value: "19", label: "Public Hold" },
  { value: "5", label: "DND" },
  { value: "32", label: "SMS" },
  { value: "25", label: "Record" },
  { value: "35", label: "URL Record" },
  { value: "24", label: "Paging" },
  { value: "4", label: "Private Hold" },
  { value: "34", label: "Hot Desking" },
  { value: "42", label: "ACD" },
  { value: "41", label: "Zero Touch" },
  { value: "17", label: "URL" },
  { value: "29", label: "Directory" },
  { value: "66", label: "Paging List" },
];

export const deviceProgramableKeyOptions = [
  { value: "", label: "" },
  { value: "0", label: "N/A" },
  { value: "13", label: "SpeedDial" },
  { value: "9", label: "Call Pickup" },
  { value: "23", label: "Group Pickup" },
  { value: "14", label: "Intercom" },
  { value: "40", label: "Prefix" },
  { value: "45", label: "Local Group" },
  { value: "22", label: "XML Group" },
  { value: "27", label: "XML Browser" },
  { value: "28", label: "History" },
  { value: "30", label: "Menu" },
  { value: "2", label: "Forward" },
  { value: "5", label: "DND" },
  { value: "8", label: "SMS" },
  { value: "32", label: "New SMS" },
  { value: "47", label: "XML Directory" },
  { value: "33", label: "Status" },
  { value: "24", label: "Paging" },
  { value: "43", label: "Local Phonebook" },
  { value: "34", label: "Hot Desking" },
  { value: "42", label: "ACD" },
  { value: "41", label: "Zero Touch" },
  { value: "44", label: "Broadsoft Phonebook" },
  { value: "48", label: "Switch Account Up" },
  { value: "49", label: "Switch Account Down" },
  { value: "29", label: "Directory" },
  { value: "66", label: "Paging List" },
];

export const roomDataSource = [
  { label: "All Rooms", value: "" },
  { label: "Clean", value: "31" },
  { label: "Not Clean", value: "32" },
  { label: "OOO", value: "33" },
  { label: "Maid Present-Pickup", value: "34" },
  { label: "To Be Inspected", value: "35" },
  { label: "Occupied-Clean", value: "36" },
  { label: "Occupied-Not Clean", value: "37" },
  { label: "Vacant-Clean", value: "38" },
  { label: "Vacant-Not Clean", value: "39" },
  { label: "Occupied-Inspected", value: "40" },
  { label: "Vacant-Inspected", value: "41" },
];
